(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json'.");
    }
    globalThis['kotlinx-serialization-kotlinx-serialization-json'] = factory(typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined' ? {} : globalThis['kotlinx-serialization-kotlinx-serialization-json'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var EmptySerializersModule = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var protoOf = kotlin_kotlin.$_$.ba;
  var initMetadataForObject = kotlin_kotlin.$_$.j9;
  var VOID = kotlin_kotlin.$_$.b;
  var Unit_instance = kotlin_kotlin.$_$.p2;
  var initMetadataForClass = kotlin_kotlin.$_$.e9;
  var toString = kotlin_kotlin.$_$.da;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.r3;
  var charSequenceLength = kotlin_kotlin.$_$.t8;
  var charSequenceGet = kotlin_kotlin.$_$.s8;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.d;
  var equals = kotlin_kotlin.$_$.y8;
  var toString_0 = kotlin_kotlin.$_$.sd;
  var Enum = kotlin_kotlin.$_$.lc;
  var Decoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m1;
  var CompositeDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k1;
  var initMetadataForInterface = kotlin_kotlin.$_$.h9;
  var initMetadataForCompanion = kotlin_kotlin.$_$.f9;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.k3;
  var hashCode = kotlin_kotlin.$_$.d9;
  var joinToString = kotlin_kotlin.$_$.o5;
  var THROW_CCE = kotlin_kotlin.$_$.tc;
  var KtMap = kotlin_kotlin.$_$.j4;
  var KtList = kotlin_kotlin.$_$.h4;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y1;
  var getKClassFromExpression = kotlin_kotlin.$_$.ra;
  var getBooleanHashCode = kotlin_kotlin.$_$.z8;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var toDouble = kotlin_kotlin.$_$.tb;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.d2;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var InlinePrimitiveDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var SerializableWith = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.c3;
  var SEALED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var buildSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g1;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.qd;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
  var ENUM_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var toLongOrNull = kotlin_kotlin.$_$.wb;
  var toULongOrNull = kotlin_kotlin.$_$.zb;
  var ULong = kotlin_kotlin.$_$.bd;
  var Companion_getInstance = kotlin_kotlin.$_$.n2;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.e1;
  var toDoubleOrNull = kotlin_kotlin.$_$.sb;
  var toBooleanStrictOrNull = kotlin_kotlin.$_$.rb;
  var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var SerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e1;
  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var isInterface = kotlin_kotlin.$_$.s9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.t3;
  var KProperty1 = kotlin_kotlin.$_$.ua;
  var getPropertyCallableRef = kotlin_kotlin.$_$.b9;
  var constructCallableReference = kotlin_kotlin.$_$.w8;
  var lazy = kotlin_kotlin.$_$.pd;
  var get_isNullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
  var get_isInline = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c1;
  var get_annotations = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var Encoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n1;
  var CompositeEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l1;
  var fromInt = kotlin_kotlin.$_$.z7;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.u;
  var UInt__toString_impl_dbgl21 = kotlin_kotlin.$_$.w;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.d1;
  var ULong__toString_impl_f9au7k = kotlin_kotlin.$_$.f1;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.l;
  var UByte__toString_impl_v72jg = kotlin_kotlin.$_$.n;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.m1;
  var UShort__toString_impl_edaoee = kotlin_kotlin.$_$.o1;
  var ElementMarker = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var captureStack = kotlin_kotlin.$_$.o8;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var SerializationException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
  var charSequenceSubSequence = kotlin_kotlin.$_$.u8;
  var coerceAtLeast = kotlin_kotlin.$_$.ha;
  var coerceAtMost = kotlin_kotlin.$_$.ja;
  var Collection = kotlin_kotlin.$_$.c4;
  var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var CLASS_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.t2;
  var singleOrNull = kotlin_kotlin.$_$.i6;
  var emptyMap = kotlin_kotlin.$_$.f5;
  var getValue = kotlin_kotlin.$_$.k5;
  var copyOf = kotlin_kotlin.$_$.b5;
  var copyOf_0 = kotlin_kotlin.$_$.c5;
  var LIST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
  var CONTEXTUAL_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var PolymorphicKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
  var PrimitiveKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z;
  var MAP_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
  var ENUM = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f1;
  var contextual = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d2;
  var SerializersModuleCollector = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var DeepRecursiveFunction = kotlin_kotlin.$_$.jc;
  var invoke = kotlin_kotlin.$_$.ld;
  var CoroutineImpl = kotlin_kotlin.$_$.m7;
  var DeepRecursiveScope = kotlin_kotlin.$_$.kc;
  var Unit = kotlin_kotlin.$_$.ed;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.x6;
  var initMetadataForLambda = kotlin_kotlin.$_$.i9;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.g9;
  var SealedClassSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
  var jsonCachedSerialNames = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
  var AbstractDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
  var AbstractPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
  var DeserializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f2;
  var getKClass = kotlin_kotlin.$_$.sa;
  var findPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m2;
  var ensureNotNull = kotlin_kotlin.$_$.kd;
  var substringBefore = kotlin_kotlin.$_$.ob;
  var removeSuffix = kotlin_kotlin.$_$.fb;
  var substringAfter = kotlin_kotlin.$_$.mb;
  var contains = kotlin_kotlin.$_$.wa;
  var plus = kotlin_kotlin.$_$.rd;
  var MissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var convertToByte = kotlin_kotlin.$_$.u7;
  var equalsLong = kotlin_kotlin.$_$.y7;
  var convertToShort = kotlin_kotlin.$_$.w7;
  var convertToInt = kotlin_kotlin.$_$.v7;
  var IllegalArgumentException = kotlin_kotlin.$_$.oc;
  var isFinite = kotlin_kotlin.$_$.nd;
  var isFinite_0 = kotlin_kotlin.$_$.md;
  var charCodeAt = kotlin_kotlin.$_$.r8;
  var toUInt = kotlin_kotlin.$_$.yb;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.v;
  var toULong = kotlin_kotlin.$_$.ac;
  var toUByte = kotlin_kotlin.$_$.xb;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.m;
  var toUShort = kotlin_kotlin.$_$.bc;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.n1;
  var objectCreate = kotlin_kotlin.$_$.aa;
  var AbstractEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j1;
  var OBJECT_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h;
  var findPolymorphicSerializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var SerializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l2;
  var toString_1 = kotlin_kotlin.$_$.g;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.m2;
  var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.l2;
  var serializer_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.o2;
  var serializer_3 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
  var setOf = kotlin_kotlin.$_$.g6;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.f;
  var numberToChar = kotlin_kotlin.$_$.y9;
  var equals_0 = kotlin_kotlin.$_$.ya;
  var toByte = kotlin_kotlin.$_$.ca;
  var startsWith = kotlin_kotlin.$_$.kb;
  var NamedValueDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
  var numberRangeToNumber = kotlin_kotlin.$_$.x9;
  var ClosedRange = kotlin_kotlin.$_$.ga;
  var contains_0 = kotlin_kotlin.$_$.la;
  var single = kotlin_kotlin.$_$.ib;
  var Char = kotlin_kotlin.$_$.hc;
  var emptySet = kotlin_kotlin.$_$.g5;
  var plus_0 = kotlin_kotlin.$_$.a6;
  var toInt = kotlin_kotlin.$_$.vb;
  var toList = kotlin_kotlin.$_$.o6;
  var enumEntries = kotlin_kotlin.$_$.o7;
  var getContextualDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h1;
  var toNumber = kotlin_kotlin.$_$.j8;
  var last = kotlin_kotlin.$_$.s5;
  var removeLast = kotlin_kotlin.$_$.e6;
  var lastIndexOf = kotlin_kotlin.$_$.cb;
  var Long = kotlin_kotlin.$_$.pc;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.e;
  var multiply = kotlin_kotlin.$_$.e8;
  var add = kotlin_kotlin.$_$.r7;
  var subtract = kotlin_kotlin.$_$.i8;
  var compare = kotlin_kotlin.$_$.t7;
  var numberToLong = kotlin_kotlin.$_$.g8;
  var negate = kotlin_kotlin.$_$.f8;
  var charArray = kotlin_kotlin.$_$.q8;
  var indexOf = kotlin_kotlin.$_$.za;
  var indexOf_0 = kotlin_kotlin.$_$.ab;
  var substring = kotlin_kotlin.$_$.pb;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.j3;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.v2;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Json, 'Json');
  initMetadataForObject(Default, 'Default', VOID, Json);
  initMetadataForClass(JsonBuilder, 'JsonBuilder');
  initMetadataForClass(JsonImpl, 'JsonImpl', VOID, Json);
  initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
  initMetadataForClass(JsonIgnoreUnknownKeys, 'JsonIgnoreUnknownKeys');
  initMetadataForClass(JsonNames, 'JsonNames');
  initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
  initMetadataForClass(ClassDiscriminatorMode, 'ClassDiscriminatorMode', VOID, Enum);
  initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(JsonObject, 'JsonObject', VOID, JsonElement, [KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(JsonArray, 'JsonArray', VOID, JsonElement, [KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
  initMetadataForObject(JsonNull, 'JsonNull', VOID, JsonPrimitive, [SerializerFactory], VOID, VOID, {0: JsonNullSerializer_getInstance});
  initMetadataForClass(JsonLiteral, 'JsonLiteral', VOID, JsonPrimitive);
  initMetadataForClass(JsonObjectBuilder, 'JsonObjectBuilder');
  initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
  initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForClass(Composer, 'Composer');
  initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', VOID, Composer);
  initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', VOID, Composer);
  initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', VOID, Composer);
  initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
  initMetadataForClass(JsonException, 'JsonException', VOID, SerializationException);
  initMetadataForClass(JsonDecodingException, 'JsonDecodingException', VOID, JsonException);
  initMetadataForClass(JsonEncodingException, 'JsonEncodingException', VOID, JsonException);
  initMetadataForObject(Tombstone, 'Tombstone');
  initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
  initMetadataForClass(JsonSerializersModuleValidator, 'JsonSerializersModuleValidator', VOID, VOID, [SerializersModuleCollector]);
  initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($readObjectCOROUTINE$, CoroutineImpl);
  initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [1]);
  initMetadataForClass(Key, 'Key', Key);
  initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
  initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
  initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, AbstractDecoder, [JsonDecoder]);
  initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', VOID, AbstractDecoder);
  initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, AbstractEncoder, [JsonEncoder]);
  initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, NamedValueDecoder, [JsonDecoder]);
  initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder', VOID, JsonTreeDecoder);
  initMetadataForClass(WriteMode, 'WriteMode', VOID, Enum);
  initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
  initMetadataForObject(CharMappings, 'CharMappings');
  initMetadataForClass(StringJsonLexer, 'StringJsonLexer', VOID, AbstractJsonLexer);
  initMetadataForClass(StringJsonLexerWithComments, 'StringJsonLexerWithComments', VOID, StringJsonLexer);
  initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
  //endregion
  function Default() {
    Default_instance = this;
    Json.call(this, new JsonConfiguration(), EmptySerializersModule());
  }
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Json(configuration, serializersModule) {
    Default_getInstance();
    this.e13_1 = configuration;
    this.f13_1 = serializersModule;
    this.g13_1 = new DescriptorSchemaCache();
  }
  protoOf(Json).um = function () {
    return this.f13_1;
  };
  protoOf(Json).h13 = function (serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.k13();
    }
  };
  protoOf(Json).i13 = function (deserializer, string) {
    var lexer = StringJsonLexer_0(this, string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.ej(), null);
    var result = input.em(deserializer);
    lexer.x13();
    return result;
  };
  function Json_0(from, builderAction) {
    from = from === VOID ? Default_getInstance() : from;
    var builder = new JsonBuilder(from);
    builderAction(builder);
    var conf = builder.q14();
    return new JsonImpl(conf, builder.p14_1);
  }
  function JsonBuilder(json) {
    this.y13_1 = json.e13_1.r14_1;
    this.z13_1 = json.e13_1.w14_1;
    this.a14_1 = json.e13_1.s14_1;
    this.b14_1 = json.e13_1.t14_1;
    this.c14_1 = json.e13_1.v14_1;
    this.d14_1 = json.e13_1.x14_1;
    this.e14_1 = json.e13_1.y14_1;
    this.f14_1 = json.e13_1.a15_1;
    this.g14_1 = json.e13_1.h15_1;
    this.h14_1 = json.e13_1.c15_1;
    this.i14_1 = json.e13_1.d15_1;
    this.j14_1 = json.e13_1.e15_1;
    this.k14_1 = json.e13_1.f15_1;
    this.l14_1 = json.e13_1.g15_1;
    this.m14_1 = json.e13_1.b15_1;
    this.n14_1 = json.e13_1.u14_1;
    this.o14_1 = json.e13_1.z14_1;
    this.p14_1 = json.um();
  }
  protoOf(JsonBuilder).q14 = function () {
    if (this.o14_1) {
      // Inline function 'kotlin.require' call
      if (!(this.f14_1 === 'type')) {
        var message = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.require' call
      if (!this.g14_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
        var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
    }
    if (!this.c14_1) {
      // Inline function 'kotlin.require' call
      if (!(this.d14_1 === '    ')) {
        var message_1 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }
    } else if (!(this.d14_1 === '    ')) {
      var tmp0 = this.d14_1;
      var tmp$ret$6;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(tmp0)) {
          var element = charSequenceGet(tmp0, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
            tmp$ret$6 = false;
            break $l$block;
          }
        }
        tmp$ret$6 = true;
      }
      var allWhitespaces = tmp$ret$6;
      // Inline function 'kotlin.require' call
      if (!allWhitespaces) {
        var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.d14_1;
        throw IllegalArgumentException_init_$Create$(toString(message_2));
      }
    }
    return new JsonConfiguration(this.y13_1, this.a14_1, this.b14_1, this.n14_1, this.c14_1, this.z13_1, this.d14_1, this.e14_1, this.o14_1, this.f14_1, this.m14_1, this.h14_1, this.i14_1, this.j14_1, this.k14_1, this.l14_1, this.g14_1);
  };
  function validateConfiguration($this) {
    if (equals($this.um(), EmptySerializersModule()))
      return Unit_instance;
    var collector = new JsonSerializersModuleValidator($this.e13_1);
    $this.um().m12(collector);
  }
  function JsonImpl(configuration, module_0) {
    Json.call(this, configuration, module_0);
    validateConfiguration(this);
  }
  function JsonClassDiscriminator() {
  }
  function JsonIgnoreUnknownKeys() {
  }
  function JsonNames() {
  }
  function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
    allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
    allowComments = allowComments === VOID ? false : allowComments;
    classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
    this.r14_1 = encodeDefaults;
    this.s14_1 = ignoreUnknownKeys;
    this.t14_1 = isLenient;
    this.u14_1 = allowStructuredMapKeys;
    this.v14_1 = prettyPrint;
    this.w14_1 = explicitNulls;
    this.x14_1 = prettyPrintIndent;
    this.y14_1 = coerceInputValues;
    this.z14_1 = useArrayPolymorphism;
    this.a15_1 = classDiscriminator;
    this.b15_1 = allowSpecialFloatingPointValues;
    this.c15_1 = useAlternativeNames;
    this.d15_1 = namingStrategy;
    this.e15_1 = decodeEnumsCaseInsensitive;
    this.f15_1 = allowTrailingComma;
    this.g15_1 = allowComments;
    this.h15_1 = classDiscriminatorMode;
  }
  protoOf(JsonConfiguration).toString = function () {
    return 'JsonConfiguration(encodeDefaults=' + this.r14_1 + ', ignoreUnknownKeys=' + this.s14_1 + ', isLenient=' + this.t14_1 + ', ' + ('allowStructuredMapKeys=' + this.u14_1 + ', prettyPrint=' + this.v14_1 + ', explicitNulls=' + this.w14_1 + ', ') + ("prettyPrintIndent='" + this.x14_1 + "', coerceInputValues=" + this.y14_1 + ', useArrayPolymorphism=' + this.z14_1 + ', ') + ("classDiscriminator='" + this.a15_1 + "', allowSpecialFloatingPointValues=" + this.b15_1 + ', ') + ('useAlternativeNames=' + this.c15_1 + ', namingStrategy=' + toString_0(this.d15_1) + ', decodeEnumsCaseInsensitive=' + this.e15_1 + ', ') + ('allowTrailingComma=' + this.f15_1 + ', allowComments=' + this.g15_1 + ', classDiscriminatorMode=' + this.h15_1.toString() + ')');
  };
  var ClassDiscriminatorMode_NONE_instance;
  var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
  var ClassDiscriminatorMode_POLYMORPHIC_instance;
  var ClassDiscriminatorMode_entriesInitialized;
  function ClassDiscriminatorMode_initEntries() {
    if (ClassDiscriminatorMode_entriesInitialized)
      return Unit_instance;
    ClassDiscriminatorMode_entriesInitialized = true;
    ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
    ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
    ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
  }
  function ClassDiscriminatorMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ClassDiscriminatorMode_NONE_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_NONE_instance;
  }
  function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_POLYMORPHIC_instance;
  }
  function JsonDecoder() {
  }
  function get_jsonUnquotedLiteralDescriptor() {
    _init_properties_JsonElement_kt__7cbdc2();
    return jsonUnquotedLiteralDescriptor;
  }
  var jsonUnquotedLiteralDescriptor;
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance_3() {
    return Companion_instance;
  }
  function JsonElement() {
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_4() {
    return Companion_instance_0;
  }
  function JsonPrimitive() {
    JsonElement.call(this);
  }
  protoOf(JsonPrimitive).toString = function () {
    return this.k15();
  };
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_5() {
    return Companion_instance_1;
  }
  function JsonObject$toString$lambda(_destruct__k2r9zo) {
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.e2();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.f2();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    printQuoted(this_0, k);
    this_0.s(_Char___init__impl__6a9atx(58));
    this_0.w(v);
    return this_0.toString();
  }
  function JsonObject(content) {
    JsonElement.call(this);
    this.l15_1 = content;
  }
  protoOf(JsonObject).equals = function (other) {
    return equals(this.l15_1, other);
  };
  protoOf(JsonObject).hashCode = function () {
    return hashCode(this.l15_1);
  };
  protoOf(JsonObject).toString = function () {
    var tmp = this.l15_1.l2();
    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  };
  protoOf(JsonObject).r = function () {
    return this.l15_1.r();
  };
  protoOf(JsonObject).m15 = function (key) {
    return this.l15_1.g2(key);
  };
  protoOf(JsonObject).g2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.m15((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).n15 = function (key) {
    return this.l15_1.i2(key);
  };
  protoOf(JsonObject).i2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.n15((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).z = function () {
    return this.l15_1.z();
  };
  protoOf(JsonObject).j2 = function () {
    return this.l15_1.j2();
  };
  protoOf(JsonObject).k2 = function () {
    return this.l15_1.k2();
  };
  protoOf(JsonObject).l2 = function () {
    return this.l15_1.l2();
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_6() {
    return Companion_instance_2;
  }
  function JsonArray(content) {
    JsonElement.call(this);
    this.o15_1 = content;
  }
  protoOf(JsonArray).equals = function (other) {
    return equals(this.o15_1, other);
  };
  protoOf(JsonArray).hashCode = function () {
    return hashCode(this.o15_1);
  };
  protoOf(JsonArray).toString = function () {
    return joinToString(this.o15_1, ',', '[', ']');
  };
  protoOf(JsonArray).r = function () {
    return this.o15_1.r();
  };
  protoOf(JsonArray).t = function () {
    return this.o15_1.t();
  };
  protoOf(JsonArray).a1 = function (index) {
    return this.o15_1.a1(index);
  };
  protoOf(JsonArray).z = function () {
    return this.o15_1.z();
  };
  function JsonNull() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this.p15_1 = 'null';
  }
  protoOf(JsonNull).k15 = function () {
    return this.p15_1;
  };
  protoOf(JsonNull).q15 = function () {
    return JsonNullSerializer_getInstance();
  };
  protoOf(JsonNull).tu = function (typeParamsSerializers) {
    return this.q15();
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull();
    return JsonNull_instance;
  }
  function JsonLiteral(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    JsonPrimitive.call(this);
    this.r15_1 = isString;
    this.s15_1 = coerceToInlineType;
    this.t15_1 = toString(body);
    if (!(this.s15_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!this.s15_1.nk()) {
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
  }
  protoOf(JsonLiteral).k15 = function () {
    return this.t15_1;
  };
  protoOf(JsonLiteral).toString = function () {
    var tmp;
    if (this.r15_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$();
      printQuoted(this_0, this.t15_1);
      tmp = this_0.toString();
    } else {
      tmp = this.t15_1;
    }
    return tmp;
  };
  protoOf(JsonLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.r15_1 === other.r15_1))
      return false;
    if (!(this.t15_1 === other.t15_1))
      return false;
    return true;
  };
  protoOf(JsonLiteral).hashCode = function () {
    var result = getBooleanHashCode(this.r15_1);
    result = imul(31, result) + getStringHashCode(this.t15_1) | 0;
    return result;
  };
  function get_booleanOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toBooleanStrictOrNull_0(_this__u8e3s4.k15());
  }
  function parseLongImpl(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return (new StringJsonLexer(_this__u8e3s4.k15())).u15();
  }
  function get_float(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlin.text.toFloat' call
    var this_0 = _this__u8e3s4.k15();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return toDouble(this_0);
  }
  function get_double(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDouble(_this__u8e3s4.k15());
  }
  function get_contentOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp;
    if (_this__u8e3s4 instanceof JsonNull) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4.k15();
    }
    return tmp;
  }
  function JsonPrimitive_0(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function JsonPrimitive_1(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  function JsonPrimitive_2(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  function get_jsonPrimitive(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error(_this__u8e3s4, 'JsonPrimitive');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function error(_this__u8e3s4, element) {
    _init_properties_JsonElement_kt__7cbdc2();
    throw IllegalArgumentException_init_$Create$('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
  }
  var properties_initialized_JsonElement_kt_abxy8s;
  function _init_properties_JsonElement_kt__7cbdc2() {
    if (!properties_initialized_JsonElement_kt_abxy8s) {
      properties_initialized_JsonElement_kt_abxy8s = true;
      jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
    }
  }
  function JsonObjectBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.v15_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(JsonObjectBuilder).w15 = function (key, element) {
    return this.v15_1.m2(key, element);
  };
  protoOf(JsonObjectBuilder).q14 = function () {
    return new JsonObject(this.v15_1);
  };
  function put(_this__u8e3s4, key, value) {
    return _this__u8e3s4.w15(key, JsonPrimitive_0(value));
  }
  function put_0(_this__u8e3s4, key, value) {
    return _this__u8e3s4.w15(key, JsonPrimitive_1(value));
  }
  function put_1(_this__u8e3s4, key, value) {
    return _this__u8e3s4.w15(key, JsonPrimitive_2(value));
  }
  function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.sj('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
    $this$buildSerialDescriptor.sj('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
    $this$buildSerialDescriptor.sj('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
    $this$buildSerialDescriptor.sj('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
    $this$buildSerialDescriptor.sj('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
    return Unit_instance;
  }
  function JsonElementSerializer$descriptor$lambda$lambda() {
    return JsonPrimitiveSerializer_getInstance().x15_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_0() {
    return JsonNullSerializer_getInstance().y15_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_1() {
    return JsonLiteralSerializer_getInstance().z15_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_2() {
    return JsonObjectSerializer_getInstance().a16_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_3() {
    return JsonArraySerializer_getInstance().b16_1;
  }
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.c16_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  protoOf(JsonElementSerializer).ej = function () {
    return this.c16_1;
  };
  protoOf(JsonElementSerializer).d16 = function (encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.xn(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject) {
        encoder.xn(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray) {
          encoder.xn(JsonArraySerializer_getInstance(), value);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  };
  protoOf(JsonElementSerializer).fj = function (encoder, value) {
    return this.d16(encoder, value instanceof JsonElement ? value : THROW_CCE());
  };
  protoOf(JsonElementSerializer).gj = function (decoder) {
    var input = asJsonDecoder(decoder);
    return input.j15();
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function defer(deferred) {
    return new defer$1(deferred);
  }
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    this.x15_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  protoOf(JsonPrimitiveSerializer).ej = function () {
    return this.x15_1;
  };
  protoOf(JsonPrimitiveSerializer).e16 = function (encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      encoder.xn(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.xn(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(JsonPrimitiveSerializer).fj = function (encoder, value) {
    return this.e16(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  };
  protoOf(JsonPrimitiveSerializer).gj = function (decoder) {
    var result = asJsonDecoder(decoder).j15();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    this.y15_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  protoOf(JsonNullSerializer).ej = function () {
    return this.y15_1;
  };
  protoOf(JsonNullSerializer).f16 = function (encoder, value) {
    verify(encoder);
    encoder.an();
  };
  protoOf(JsonNullSerializer).fj = function (encoder, value) {
    return this.f16(encoder, value instanceof JsonNull ? value : THROW_CCE());
  };
  protoOf(JsonNullSerializer).gj = function (decoder) {
    verify_0(decoder);
    if (decoder.ql()) {
      throw new JsonDecodingException("Expected 'null' literal");
    }
    decoder.rl();
    return JsonNull_getInstance();
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this.z15_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  protoOf(JsonLiteralSerializer).ej = function () {
    return this.z15_1;
  };
  protoOf(JsonLiteralSerializer).g16 = function (encoder, value) {
    verify(encoder);
    if (value.r15_1) {
      return encoder.jn(value.t15_1);
    }
    if (!(value.s15_1 == null)) {
      return encoder.ln(value.s15_1).jn(value.t15_1);
    }
    var tmp0_safe_receiver = toLongOrNull(value.t15_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.fn(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = toULongOrNull(value.t15_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      var tmp_0 = tmp1_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).ki_1;
      var tmp_1 = encoder.ln(serializer_0(Companion_getInstance()).ej());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$4 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.fn(tmp$ret$4);
      return Unit_instance;
    }
    var tmp2_safe_receiver = toDoubleOrNull(value.t15_1);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.hn(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = toBooleanStrictOrNull(value.t15_1);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.bn(tmp3_safe_receiver);
    }
    encoder.jn(value.t15_1);
  };
  protoOf(JsonLiteralSerializer).fj = function (encoder, value) {
    return this.g16(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  };
  protoOf(JsonLiteralSerializer).gj = function (decoder) {
    var result = asJsonDecoder(decoder).j15();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    this.h16_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).ej();
    this.i16_1 = 'kotlinx.serialization.json.JsonObject';
  }
  protoOf(JsonObjectDescriptor).lk = function () {
    return this.i16_1;
  };
  protoOf(JsonObjectDescriptor).qk = function (index) {
    return this.h16_1.qk(index);
  };
  protoOf(JsonObjectDescriptor).rk = function (name) {
    return this.h16_1.rk(name);
  };
  protoOf(JsonObjectDescriptor).sk = function (index) {
    return this.h16_1.sk(index);
  };
  protoOf(JsonObjectDescriptor).tk = function (index) {
    return this.h16_1.tk(index);
  };
  protoOf(JsonObjectDescriptor).uk = function (index) {
    return this.h16_1.uk(index);
  };
  protoOf(JsonObjectDescriptor).mk = function () {
    return this.h16_1.mk();
  };
  protoOf(JsonObjectDescriptor).ek = function () {
    return this.h16_1.ek();
  };
  protoOf(JsonObjectDescriptor).nk = function () {
    return this.h16_1.nk();
  };
  protoOf(JsonObjectDescriptor).ok = function () {
    return this.h16_1.ok();
  };
  protoOf(JsonObjectDescriptor).pk = function () {
    return this.h16_1.pk();
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this.a16_1 = JsonObjectDescriptor_getInstance();
  }
  protoOf(JsonObjectSerializer).ej = function () {
    return this.a16_1;
  };
  protoOf(JsonObjectSerializer).j16 = function (encoder, value) {
    verify(encoder);
    MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).fj(encoder, value);
  };
  protoOf(JsonObjectSerializer).fj = function (encoder, value) {
    return this.j16(encoder, value instanceof JsonObject ? value : THROW_CCE());
  };
  protoOf(JsonObjectSerializer).gj = function (decoder) {
    verify_0(decoder);
    return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).gj(decoder));
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    this.k16_1 = ListSerializer(JsonElementSerializer_getInstance()).ej();
    this.l16_1 = 'kotlinx.serialization.json.JsonArray';
  }
  protoOf(JsonArrayDescriptor).lk = function () {
    return this.l16_1;
  };
  protoOf(JsonArrayDescriptor).qk = function (index) {
    return this.k16_1.qk(index);
  };
  protoOf(JsonArrayDescriptor).rk = function (name) {
    return this.k16_1.rk(name);
  };
  protoOf(JsonArrayDescriptor).sk = function (index) {
    return this.k16_1.sk(index);
  };
  protoOf(JsonArrayDescriptor).tk = function (index) {
    return this.k16_1.tk(index);
  };
  protoOf(JsonArrayDescriptor).uk = function (index) {
    return this.k16_1.uk(index);
  };
  protoOf(JsonArrayDescriptor).mk = function () {
    return this.k16_1.mk();
  };
  protoOf(JsonArrayDescriptor).ek = function () {
    return this.k16_1.ek();
  };
  protoOf(JsonArrayDescriptor).nk = function () {
    return this.k16_1.nk();
  };
  protoOf(JsonArrayDescriptor).ok = function () {
    return this.k16_1.ok();
  };
  protoOf(JsonArrayDescriptor).pk = function () {
    return this.k16_1.pk();
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this.b16_1 = JsonArrayDescriptor_getInstance();
  }
  protoOf(JsonArraySerializer).ej = function () {
    return this.b16_1;
  };
  protoOf(JsonArraySerializer).m16 = function (encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).fj(encoder, value);
  };
  protoOf(JsonArraySerializer).fj = function (encoder, value) {
    return this.m16(encoder, value instanceof JsonArray ? value : THROW_CCE());
  };
  protoOf(JsonArraySerializer).gj = function (decoder) {
    verify_0(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).gj(decoder));
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function verify(encoder) {
    asJsonEncoder(encoder);
  }
  function asJsonDecoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function verify_0(decoder) {
    asJsonDecoder(decoder);
  }
  function asJsonEncoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_original__l7ku1m($this) {
    var tmp0 = $this.n16_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('original', 1, tmp, defer$o$_get_original_$ref_3cje7k(), null);
    return tmp0.f2();
  }
  function defer$o$_get_original_$ref_3cje7k() {
    return constructCallableReference(function (p0) {
      return _get_original__l7ku1m(p0);
    }, 1, 0, 9);
  }
  function defer$1($deferred) {
    this.n16_1 = lazy($deferred);
  }
  protoOf(defer$1).lk = function () {
    return _get_original__l7ku1m(this).lk();
  };
  protoOf(defer$1).mk = function () {
    return _get_original__l7ku1m(this).mk();
  };
  protoOf(defer$1).ok = function () {
    return _get_original__l7ku1m(this).ok();
  };
  protoOf(defer$1).qk = function (index) {
    return _get_original__l7ku1m(this).qk(index);
  };
  protoOf(defer$1).rk = function (name) {
    return _get_original__l7ku1m(this).rk(name);
  };
  protoOf(defer$1).sk = function (index) {
    return _get_original__l7ku1m(this).sk(index);
  };
  protoOf(defer$1).tk = function (index) {
    return _get_original__l7ku1m(this).tk(index);
  };
  protoOf(defer$1).uk = function (index) {
    return _get_original__l7ku1m(this).uk(index);
  };
  function JsonEncoder() {
  }
  function Composer(writer) {
    this.o16_1 = writer;
    this.p16_1 = true;
  }
  protoOf(Composer).q16 = function () {
    this.p16_1 = true;
  };
  protoOf(Composer).r16 = function () {
    return Unit_instance;
  };
  protoOf(Composer).s16 = function () {
    this.p16_1 = false;
  };
  protoOf(Composer).t16 = function () {
    this.p16_1 = false;
  };
  protoOf(Composer).u16 = function () {
    return Unit_instance;
  };
  protoOf(Composer).v16 = function (v) {
    return this.o16_1.w16(v);
  };
  protoOf(Composer).x16 = function (v) {
    return this.o16_1.y16(v);
  };
  protoOf(Composer).z16 = function (v) {
    return this.o16_1.y16(v.toString());
  };
  protoOf(Composer).a17 = function (v) {
    return this.o16_1.y16(v.toString());
  };
  protoOf(Composer).b17 = function (v) {
    return this.o16_1.c17(fromInt(v));
  };
  protoOf(Composer).d17 = function (v) {
    return this.o16_1.c17(fromInt(v));
  };
  protoOf(Composer).e17 = function (v) {
    return this.o16_1.c17(fromInt(v));
  };
  protoOf(Composer).f17 = function (v) {
    return this.o16_1.c17(v);
  };
  protoOf(Composer).g17 = function (v) {
    return this.o16_1.y16(v.toString());
  };
  protoOf(Composer).h17 = function (value) {
    return this.o16_1.i17(value);
  };
  function Composer_0(sb, json) {
    return json.e13_1.v14_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
  }
  function ComposerForUnsignedNumbers(writer, forceQuoting) {
    Composer.call(this, writer);
    this.l17_1 = forceQuoting;
  }
  protoOf(ComposerForUnsignedNumbers).e17 = function (v) {
    if (this.l17_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.h17(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.x16(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).f17 = function (v) {
    if (this.l17_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.h17(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.x16(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).b17 = function (v) {
    if (this.l17_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.h17(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.x16(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).d17 = function (v) {
    if (this.l17_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.h17(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.x16(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  };
  function ComposerForUnquotedLiterals(writer, forceQuoting) {
    Composer.call(this, writer);
    this.o17_1 = forceQuoting;
  }
  protoOf(ComposerForUnquotedLiterals).h17 = function (value) {
    if (this.o17_1) {
      protoOf(Composer).h17.call(this, value);
    } else {
      protoOf(Composer).x16.call(this, value);
    }
  };
  function ComposerWithPrettyPrint(writer, json) {
    Composer.call(this, writer);
    this.r17_1 = json;
    this.s17_1 = 0;
  }
  protoOf(ComposerWithPrettyPrint).q16 = function () {
    this.p16_1 = true;
    this.s17_1 = this.s17_1 + 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).r16 = function () {
    this.s17_1 = this.s17_1 - 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).s16 = function () {
    this.p16_1 = false;
    this.x16('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.s17_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.x16(this.r17_1.e13_1.x14_1);
      }
       while (inductionVariable < times);
  };
  protoOf(ComposerWithPrettyPrint).t16 = function () {
    if (this.p16_1)
      this.p16_1 = false;
    else {
      this.s16();
    }
  };
  protoOf(ComposerWithPrettyPrint).u16 = function () {
    this.v16(_Char___init__impl__6a9atx(32));
  };
  function readIfAbsent($this, descriptor, index) {
    $this.u17_1 = (!descriptor.uk(index) && descriptor.tk(index).ek());
    return $this.u17_1;
  }
  function JsonElementMarker$readIfAbsent$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      var tmp0 = p0;
      return readIfAbsent(tmp0, p0_0, p1);
    }, 2, 0, 10, 'readIfAbsent', [p0]);
  }
  function JsonElementMarker(descriptor) {
    var tmp = this;
    tmp.t17_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.u17_1 = false;
  }
  protoOf(JsonElementMarker).v17 = function (index) {
    this.t17_1.ls(index);
  };
  protoOf(JsonElementMarker).w17 = function () {
    return this.t17_1.ms();
  };
  function JsonDecodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonDecodingException);
  }
  function JsonDecodingException_0(offset, message, input) {
    return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString(minify(input, offset)));
  }
  function JsonException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, JsonException);
  }
  function JsonDecodingException_1(offset, message) {
    return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
  }
  function minify(_this__u8e3s4, offset) {
    offset = offset === VOID ? -1 : offset;
    if (charSequenceLength(_this__u8e3s4) < 200)
      return _this__u8e3s4;
    if (offset === -1) {
      var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
      if (start <= 0)
        return _this__u8e3s4;
      // Inline function 'kotlin.text.substring' call
      var endIndex = charSequenceLength(_this__u8e3s4);
      return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
    }
    var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
    var tmp2 = coerceAtLeast(start_0, 0);
    // Inline function 'kotlin.text.substring' call
    var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
    return prefix + toString(charSequenceSubSequence(_this__u8e3s4, tmp2, endIndex_0)) + suffix;
  }
  function invalidTrailingComma(_this__u8e3s4, entity) {
    entity = entity === VOID ? 'object' : entity;
    _this__u8e3s4.x17('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.t13_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingComma = true' in 'Json {}' builder to support them.");
  }
  function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
    _this__u8e3s4.y17('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
  }
  function JsonEncodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonEncodingException);
  }
  function InvalidFloatingPointEncoded(value, output) {
    return new JsonEncodingException('Unexpected special floating-point value ' + toString(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output))));
  }
  function InvalidFloatingPointDecoded(value, key, output) {
    return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
  }
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException("Value of type '" + keyDescriptor.lk() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.mk().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
  }
  function unexpectedFpErrorMessage(value, key, output) {
    return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output)));
  }
  function get_JsonDeserializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonDeserializationNamesKey;
  }
  var JsonDeserializationNamesKey;
  function get_JsonSerializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonSerializationNamesKey;
  }
  var JsonSerializationNamesKey;
  function ignoreUnknownKeys(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp;
    if (json.e13_1.s14_1) {
      tmp = true;
    } else {
      var tmp0 = _this__u8e3s4.pk();
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (element instanceof JsonIgnoreUnknownKeys) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    }
    return tmp;
  }
  function getJsonNameIndex(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    if (decodeCaseInsensitive(json, _this__u8e3s4)) {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = name.toLowerCase();
      return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$0);
    }
    var strategy = namingStrategy(_this__u8e3s4, json);
    if (!(strategy == null))
      return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
    var index = _this__u8e3s4.rk(name);
    if (!(index === -3))
      return index;
    if (!json.e13_1.c15_1)
      return index;
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  }
  function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
    suffix = suffix === VOID ? '' : suffix;
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var index = getJsonNameIndex(_this__u8e3s4, json, name);
    if (index === -3)
      throw SerializationException_init_$Create$(_this__u8e3s4.lk() + " does not contain element with name '" + name + "'" + suffix);
    return index;
  }
  function getJsonElementName(_this__u8e3s4, json, index) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    return strategy == null ? _this__u8e3s4.qk(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
  }
  function namingStrategy(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return equals(_this__u8e3s4.mk(), CLASS_getInstance()) ? json.e13_1.d15_1 : null;
  }
  function deserializationNamesMap(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(_this__u8e3s4);
    var tmp_0 = get_JsonDeserializationNamesKey();
    return tmp.a18(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
  }
  function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return _this__u8e3s4.e13_1.e15_1 && equals(descriptor.mk(), ENUM_getInstance());
  }
  function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).i2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  function serializationNamesIndices(_this__u8e3s4, json, strategy) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(json);
    var tmp_0 = get_JsonSerializationNamesKey();
    return tmp.a18(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
  }
  function buildDeserializationNamesMap(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var builder = LinkedHashMap_init_$Create$();
    var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
    var strategyForClasses = namingStrategy(_this__u8e3s4, json);
    var inductionVariable = 0;
    var last = _this__u8e3s4.ok();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.filterIsInstance' call
        var tmp0 = _this__u8e3s4.sk(i);
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var destination = ArrayList_init_$Create$();
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (element instanceof JsonNames) {
            destination.x(element);
          }
        }
        var tmp0_safe_receiver = singleOrNull(destination);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b18_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable_0 = 0;
          var last_0 = tmp1_safe_receiver.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = tmp1_safe_receiver[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp;
            if (useLowercaseEnums) {
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp = element_0.toLowerCase();
            } else {
              tmp = element_0;
            }
            buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
          }
        }
        var tmp_0;
        if (useLowercaseEnums) {
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = _this__u8e3s4.qk(i).toLowerCase();
        } else if (!(strategyForClasses == null)) {
          tmp_0 = strategyForClasses.c18(_this__u8e3s4, i, _this__u8e3s4.qk(i));
        } else {
          tmp_0 = null;
        }
        var nameToPut = tmp_0;
        if (nameToPut == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
        }
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp_1;
    if (builder.r()) {
      tmp_1 = emptyMap();
    } else {
      tmp_1 = builder;
    }
    return tmp_1;
  }
  function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
    return function () {
      return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
    };
  }
  function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
    return function () {
      var tmp = 0;
      var tmp_0 = $this_serializationNamesIndices.ok();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = Array(tmp_0);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var baseName = $this_serializationNamesIndices.qk(tmp_2);
        tmp_1[tmp_2] = $strategy.c18($this_serializationNamesIndices, tmp_2, baseName);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
    var entity = equals($this_buildDeserializationNamesMap.mk(), ENUM_getInstance()) ? 'enum value' : 'property';
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).g2(name)) {
      throw new JsonException("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.qk(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.qk(getValue(_this__u8e3s4, name)) + ' in ' + toString($this_buildDeserializationNamesMap)));
    }
    // Inline function 'kotlin.collections.set' call
    _this__u8e3s4.m2(name, index);
  }
  var properties_initialized_JsonNamesMap_kt_ljpf42;
  function _init_properties_JsonNamesMap_kt__cbbp0k() {
    if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
      properties_initialized_JsonNamesMap_kt_ljpf42 = true;
      JsonDeserializationNamesKey = new Key();
      JsonSerializationNamesKey = new Key();
    }
  }
  function Tombstone() {
  }
  var Tombstone_instance;
  function Tombstone_getInstance() {
    return Tombstone_instance;
  }
  function resize($this) {
    var newSize = imul($this.f18_1, 2);
    $this.d18_1 = copyOf($this.d18_1, newSize);
    $this.e18_1 = copyOf_0($this.e18_1, newSize);
  }
  function JsonPath() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.d18_1 = Array(8);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(8);
    while (tmp_1 < 8) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.e18_1 = tmp_2;
    this.f18_1 = -1;
  }
  protoOf(JsonPath).g18 = function (sd) {
    this.f18_1 = this.f18_1 + 1 | 0;
    var depth = this.f18_1;
    if (depth === this.d18_1.length) {
      resize(this);
    }
    this.d18_1[depth] = sd;
  };
  protoOf(JsonPath).h18 = function (index) {
    this.e18_1[this.f18_1] = index;
  };
  protoOf(JsonPath).i18 = function (key) {
    var tmp;
    if (!(this.e18_1[this.f18_1] === -2)) {
      this.f18_1 = this.f18_1 + 1 | 0;
      tmp = this.f18_1 === this.d18_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.d18_1[this.f18_1] = key;
    this.e18_1[this.f18_1] = -2;
  };
  protoOf(JsonPath).j18 = function () {
    if (this.e18_1[this.f18_1] === -2) {
      this.d18_1[this.f18_1] = Tombstone_instance;
    }
  };
  protoOf(JsonPath).k18 = function () {
    var depth = this.f18_1;
    if (this.e18_1[depth] === -2) {
      this.e18_1[depth] = -1;
      this.f18_1 = this.f18_1 - 1 | 0;
    }
    if (!(this.f18_1 === -1)) {
      this.f18_1 = this.f18_1 - 1 | 0;
    }
  };
  protoOf(JsonPath).l18 = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.q('$');
    // Inline function 'kotlin.repeat' call
    var times = this.f18_1 + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = this.d18_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.mk(), LIST_getInstance())) {
            if (!(this.e18_1[index] === -1)) {
              this_0.q('[');
              this_0.pa(this.e18_1[index]);
              this_0.q(']');
            }
          } else {
            var idx = this.e18_1[index];
            if (idx >= 0) {
              this_0.q('.');
              this_0.q(element.qk(idx));
            }
          }
        } else {
          if (!(element === Tombstone_instance)) {
            this_0.q('[');
            this_0.q("'");
            this_0.w(element);
            this_0.q("'");
            this_0.q(']');
          }
        }
      }
       while (inductionVariable < times);
    return this_0.toString();
  };
  protoOf(JsonPath).toString = function () {
    return this.l18();
  };
  function checkKind($this, descriptor, actualClass) {
    var kind = descriptor.mk();
    var tmp;
    if (kind instanceof PolymorphicKind) {
      tmp = true;
    } else {
      tmp = equals(kind, CONTEXTUAL_getInstance());
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.o() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
    }
    if ($this.n18_1)
      return Unit_instance;
    if (!$this.o18_1)
      return Unit_instance;
    var tmp_0;
    var tmp_1;
    if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = kind instanceof PrimitiveKind;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = kind instanceof ENUM;
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.o() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
    }
  }
  function checkDiscriminatorCollisions($this, descriptor, actualClass) {
    var inductionVariable = 0;
    var last = descriptor.ok();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var name = descriptor.qk(i);
        if (name === $this.m18_1) {
          throw IllegalArgumentException_init_$Create$('Polymorphic serializer for ' + toString(actualClass) + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
        }
      }
       while (inductionVariable < last);
  }
  function JsonSerializersModuleValidator(configuration) {
    this.m18_1 = configuration.a15_1;
    this.n18_1 = configuration.z14_1;
    this.o18_1 = !configuration.h15_1.equals(ClassDiscriminatorMode_NONE_getInstance());
  }
  protoOf(JsonSerializersModuleValidator).v12 = function (kClass, provider) {
  };
  protoOf(JsonSerializersModuleValidator).y12 = function (baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.ej();
    checkKind(this, descriptor, actualClass);
    if (!this.n18_1 && this.o18_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }
  };
  protoOf(JsonSerializersModuleValidator).z12 = function (baseClass, defaultSerializerProvider) {
  };
  protoOf(JsonSerializersModuleValidator).a13 = function (baseClass, defaultDeserializerProvider) {
  };
  function encodeByWriter(json, writer, serializer, value) {
    var tmp = WriteMode_OBJ_getInstance();
    // Inline function 'kotlin.arrayOfNulls' call
    var size = get_entries().z();
    var tmp$ret$0 = Array(size);
    var encoder = StreamingJsonEncoder_init_$Create$(writer, json, tmp, tmp$ret$0);
    encoder.xn(serializer, value);
  }
  function readObject($this) {
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
    var lastToken = $this.y18_1.c19(6);
    if ($this.y18_1.d19() === 4) {
      $this.y18_1.y17('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.linkedMapOf' call
    var result = LinkedHashMap_init_$Create$();
    $l$loop: while ($this.y18_1.e19()) {
      var key = $this.z18_1 ? $this.y18_1.g19() : $this.y18_1.f19();
      $this.y18_1.c19(5);
      var element = $this.h19();
      // Inline function 'kotlin.collections.set' call
      result.m2(key, element);
      lastToken = $this.y18_1.i19();
      var tmp0_subject = lastToken;
      if (tmp0_subject !== 4)
        if (tmp0_subject === 7)
          break $l$loop;
        else {
          $this.y18_1.y17('Expected end of the object or comma');
        }
    }
    if (lastToken === 6) {
      $this.y18_1.c19(7);
    } else if (lastToken === 4) {
      if (!$this.a19_1) {
        invalidTrailingComma($this.y18_1);
      }
      $this.y18_1.c19(7);
    }
    return new JsonObject(result);
  }
  function readObject_0($this, $receiver, $completion) {
    var tmp = new $readObjectCOROUTINE$($this, $receiver, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function readArray($this) {
    var lastToken = $this.y18_1.i19();
    if ($this.y18_1.d19() === 4) {
      $this.y18_1.y17('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    while ($this.y18_1.e19()) {
      var element = $this.h19();
      result.x(element);
      lastToken = $this.y18_1.i19();
      if (!(lastToken === 4)) {
        var tmp0 = $this.y18_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = lastToken === 9;
        var position = tmp0.t13_1;
        if (!condition) {
          var tmp$ret$2 = 'Expected end of the array or comma';
          tmp0.y17(tmp$ret$2, position);
        }
      }
    }
    if (lastToken === 8) {
      $this.y18_1.c19(9);
    } else if (lastToken === 4) {
      if (!$this.a19_1) {
        invalidTrailingComma($this.y18_1, 'array');
      }
      $this.y18_1.c19(9);
    }
    return new JsonArray(result);
  }
  function readValue($this, isString) {
    var tmp;
    if ($this.z18_1 || !isString) {
      tmp = $this.y18_1.g19();
    } else {
      tmp = $this.y18_1.f19();
    }
    var string = tmp;
    if (!isString && string === 'null')
      return JsonNull_getInstance();
    return new JsonLiteral(string, isString);
  }
  function readDeepRecursive($this) {
    return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
  }
  function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
    this.f1a_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsonTreeReader$readDeepRecursive$slambda).j1a = function ($this$DeepRecursiveFunction, it, $completion) {
    var tmp = this.k1a($this$DeepRecursiveFunction, it, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).j8 = function (p1, p2, $completion) {
    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
    return this.j1a(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            var tmp0_subject = this.f1a_1.y18_1.d19();
            if (tmp0_subject === 1) {
              this.i1a_1 = readValue(this.f1a_1, true);
              this.t7_1 = 2;
              continue $sm;
            } else {
              if (tmp0_subject === 0) {
                this.i1a_1 = readValue(this.f1a_1, false);
                this.t7_1 = 2;
                continue $sm;
              } else {
                if (tmp0_subject === 6) {
                  this.t7_1 = 1;
                  suspendResult = readObject_0(this.f1a_1, this.g1a_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (tmp0_subject === 8) {
                    this.i1a_1 = readArray(this.f1a_1);
                    this.t7_1 = 2;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    this.f1a_1.y18_1.y17("Can't begin reading element, unexpected token");
                  }
                }
              }
            }

            break;
          case 1:
            this.i1a_1 = suspendResult;
            this.t7_1 = 2;
            continue $sm;
          case 2:
            return this.i1a_1;
          case 3:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 3) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).k1a = function ($this$DeepRecursiveFunction, it, completion) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this.f1a_1, completion);
    i.g1a_1 = $this$DeepRecursiveFunction;
    i.h1a_1 = it;
    return i;
  };
  function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$DeepRecursiveFunction, it, $completion) {
      return i.j1a($this$DeepRecursiveFunction, it, $completion);
    }, 2);
  }
  function $readObjectCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r19_1 = _this__u8e3s4;
    this.s19_1 = _this__u8e3s4_0;
  }
  protoOf($readObjectCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 5;
            this.u19_1 = this.r19_1;
            this.v19_1 = this.u19_1.y18_1.c19(6);
            if (this.u19_1.y18_1.d19() === 4) {
              this.u19_1.y18_1.y17('Unexpected leading comma');
            }

            var tmp_0 = this;
            tmp_0.t19_1 = LinkedHashMap_init_$Create$();
            this.t7_1 = 1;
            continue $sm;
          case 1:
            if (!this.u19_1.y18_1.e19()) {
              this.t7_1 = 4;
              continue $sm;
            }

            this.w19_1 = this.u19_1.z18_1 ? this.u19_1.y18_1.g19() : this.u19_1.y18_1.f19();
            this.u19_1.y18_1.c19(5);
            this.t7_1 = 2;
            suspendResult = this.s19_1.rg(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var element = suspendResult;
            var tmp0 = this.t19_1;
            var key = this.w19_1;
            tmp0.m2(key, element);
            this.v19_1 = this.u19_1.y18_1.i19();
            var tmp0_subject = this.v19_1;
            if (tmp0_subject === 4) {
              this.t7_1 = 3;
              continue $sm;
            } else {
              if (tmp0_subject === 7) {
                this.t7_1 = 4;
                continue $sm;
              } else {
                this.u19_1.y18_1.y17('Expected end of the object or comma');
              }
            }

            break;
          case 3:
            this.t7_1 = 1;
            continue $sm;
          case 4:
            if (this.v19_1 === 6) {
              this.u19_1.y18_1.c19(7);
            } else if (this.v19_1 === 4) {
              if (!this.u19_1.a19_1) {
                invalidTrailingComma(this.u19_1.y18_1);
              }
              this.u19_1.y18_1.c19(7);
            }

            return new JsonObject(this.t19_1);
          case 5:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 5) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  function JsonTreeReader(configuration, lexer) {
    this.y18_1 = lexer;
    this.z18_1 = configuration.t14_1;
    this.a19_1 = configuration.f15_1;
    this.b19_1 = 0;
  }
  protoOf(JsonTreeReader).h19 = function () {
    var token = this.y18_1.d19();
    var tmp;
    if (token === 1) {
      tmp = readValue(this, true);
    } else if (token === 0) {
      tmp = readValue(this, false);
    } else if (token === 6) {
      var tmp_0;
      this.b19_1 = this.b19_1 + 1 | 0;
      if (this.b19_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      this.b19_1 = this.b19_1 - 1 | 0;
      tmp = result;
    } else if (token === 8) {
      tmp = readArray(this);
    } else {
      this.y18_1.y17('Cannot read Json element because of unexpected ' + tokenDescription(token));
    }
    return tmp;
  };
  function classDiscriminator(_this__u8e3s4, json) {
    var _iterator__ex2g4s = _this__u8e3s4.pk().t();
    while (_iterator__ex2g4s.u()) {
      var annotation = _iterator__ex2g4s.v();
      if (annotation instanceof JsonClassDiscriminator)
        return annotation.l1a_1;
    }
    return json.e13_1.a15_1;
  }
  function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
    if (!(serializer instanceof SealedClassSerializer))
      return Unit_instance;
    if (jsonCachedSerialNames(actualSerializer.ej()).c2(classDiscriminator)) {
      var baseName = serializer.ej().lk();
      var actualName = actualSerializer.ej().lk();
      // Inline function 'kotlin.error' call
      var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function checkKind_0(kind) {
    if (kind instanceof ENUM) {
      // Inline function 'kotlin.error' call
      var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (kind instanceof PrimitiveKind) {
      // Inline function 'kotlin.error' call
      var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    if (kind instanceof PolymorphicKind) {
      // Inline function 'kotlin.error' call
      var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
      throw IllegalStateException_init_$Create$(toString(message_1));
    }
  }
  function access$validateIfSealed$tPolymorphicKt(serializer, actualSerializer, classDiscriminator) {
    return validateIfSealed(serializer, actualSerializer, classDiscriminator);
  }
  function Key() {
  }
  function DescriptorSchemaCache() {
    this.z17_1 = createMapForCache(16);
  }
  protoOf(DescriptorSchemaCache).m1a = function (descriptor, key, value) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.z17_1;
    var value_0 = this_0.i2(descriptor);
    var tmp;
    if (value_0 == null) {
      var answer = createMapForCache(2);
      this_0.m2(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var tmp0 = tmp;
    var tmp2 = key instanceof Key ? key : THROW_CCE();
    // Inline function 'kotlin.collections.set' call
    var value_1 = !(value == null) ? value : THROW_CCE();
    tmp0.m2(tmp2, value_1);
  };
  protoOf(DescriptorSchemaCache).a18 = function (descriptor, key, defaultValue) {
    var tmp0_safe_receiver = this.n1a(descriptor, key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var value = defaultValue();
    this.m1a(descriptor, key, value);
    return value;
  };
  protoOf(DescriptorSchemaCache).n1a = function (descriptor, key) {
    var tmp0_safe_receiver = this.z17_1.i2(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.i2(key instanceof Key ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  };
  function DiscriminatorHolder(discriminatorToSkip) {
    this.o1a_1 = discriminatorToSkip;
  }
  function trySkip($this, $receiver, unknownKey) {
    if ($receiver == null)
      return false;
    if ($receiver.o1a_1 === unknownKey) {
      $receiver.o1a_1 = null;
      return true;
    }
    return false;
  }
  function skipLeftoverElements($this, descriptor) {
    while (!($this.wm(descriptor) === -1)) {
    }
  }
  function checkLeadingComma($this) {
    if ($this.n13_1.d19() === 4) {
      $this.n13_1.y17('Unexpected leading comma');
    }
  }
  function decodeMapIndex($this) {
    var hasComma = false;
    var decodingKey = !(($this.p13_1 % 2 | 0) === 0);
    if (decodingKey) {
      if (!($this.p13_1 === -1)) {
        hasComma = $this.n13_1.q1a();
      }
    } else {
      $this.n13_1.p1a(_Char___init__impl__6a9atx(58));
    }
    var tmp;
    if ($this.n13_1.e19()) {
      if (decodingKey) {
        if ($this.p13_1 === -1) {
          var tmp0 = $this.n13_1;
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var condition = !hasComma;
          var position = tmp0.t13_1;
          if (!condition) {
            var tmp$ret$1 = 'Unexpected leading comma';
            tmp0.y17(tmp$ret$1, position);
          }
        } else {
          var tmp0_0 = $this.n13_1;
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var condition_0 = hasComma;
          var position_0 = tmp0_0.t13_1;
          if (!condition_0) {
            var tmp$ret$3 = 'Expected comma after the key-value pair';
            tmp0_0.y17(tmp$ret$3, position_0);
          }
        }
      }
      $this.p13_1 = $this.p13_1 + 1 | 0;
      tmp = $this.p13_1;
    } else {
      if (hasComma && !$this.l13_1.e13_1.f15_1) {
        invalidTrailingComma($this.n13_1);
      }
      tmp = -1;
    }
    return tmp;
  }
  function coerceInputValue($this, descriptor, index) {
    var tmp0 = $this.l13_1;
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var isOptional = descriptor.uk(index);
      var elementDescriptor = descriptor.tk(index);
      var tmp;
      if (isOptional && !elementDescriptor.ek()) {
        tmp = $this.n13_1.r1a(true);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_2;
      }
      if (equals(elementDescriptor.mk(), ENUM_getInstance())) {
        var tmp_0;
        if (elementDescriptor.ek()) {
          tmp_0 = $this.n13_1.r1a(false);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_2;
        }
        var tmp0_elvis_lhs = $this.n13_1.s1a($this.r13_1.t14_1);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$0 = false;
          break $l$block_2;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_1;
        var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
        var coerceToNull = !tmp0.e13_1.w14_1 && elementDescriptor.ek();
        if (enumIndex === -3 && (isOptional || coerceToNull)) {
          $this.n13_1.f19();
          tmp$ret$0 = true;
          break $l$block_2;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function decodeObjectIndex($this, descriptor) {
    var hasComma = $this.n13_1.q1a();
    while ($this.n13_1.e19()) {
      hasComma = false;
      var key = decodeStringKey($this);
      $this.n13_1.p1a(_Char___init__impl__6a9atx(58));
      var index = getJsonNameIndex(descriptor, $this.l13_1, key);
      var tmp;
      if (!(index === -3)) {
        var tmp_0;
        if ($this.r13_1.y14_1 && coerceInputValue($this, descriptor, index)) {
          hasComma = $this.n13_1.q1a();
          tmp_0 = false;
        } else {
          var tmp0_safe_receiver = $this.s13_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.v17(index);
          }
          return index;
        }
        tmp = tmp_0;
      } else {
        tmp = true;
      }
      var isUnknown = tmp;
      if (isUnknown) {
        hasComma = handleUnknown($this, descriptor, key);
      }
    }
    if (hasComma && !$this.l13_1.e13_1.f15_1) {
      invalidTrailingComma($this.n13_1);
    }
    var tmp1_safe_receiver = $this.s13_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w17();
    return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
  }
  function handleUnknown($this, descriptor, key) {
    if (ignoreUnknownKeys(descriptor, $this.l13_1) || trySkip($this, $this.q13_1, key)) {
      $this.n13_1.u1a($this.r13_1.t14_1);
    } else {
      $this.n13_1.u13_1.k18();
      $this.n13_1.t1a(key);
    }
    return $this.n13_1.q1a();
  }
  function decodeListIndex($this) {
    var hasComma = $this.n13_1.q1a();
    var tmp;
    if ($this.n13_1.e19()) {
      if (!($this.p13_1 === -1) && !hasComma) {
        $this.n13_1.y17('Expected end of the array or comma');
      }
      $this.p13_1 = $this.p13_1 + 1 | 0;
      tmp = $this.p13_1;
    } else {
      if (hasComma && !$this.l13_1.e13_1.f15_1) {
        invalidTrailingComma($this.n13_1, 'array');
      }
      tmp = -1;
    }
    return tmp;
  }
  function decodeStringKey($this) {
    var tmp;
    if ($this.r13_1.t14_1) {
      tmp = $this.n13_1.w1a();
    } else {
      tmp = $this.n13_1.v1a();
    }
    return tmp;
  }
  function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
    AbstractDecoder.call(this);
    this.l13_1 = json;
    this.m13_1 = mode;
    this.n13_1 = lexer;
    this.o13_1 = this.l13_1.um();
    this.p13_1 = -1;
    this.q13_1 = discriminatorHolder;
    this.r13_1 = this.l13_1.e13_1;
    this.s13_1 = this.r13_1.w14_1 ? null : new JsonElementMarker(descriptor);
  }
  protoOf(StreamingJsonDecoder).i15 = function () {
    return this.l13_1;
  };
  protoOf(StreamingJsonDecoder).um = function () {
    return this.o13_1;
  };
  protoOf(StreamingJsonDecoder).j15 = function () {
    return (new JsonTreeReader(this.l13_1.e13_1, this.n13_1)).h19();
  };
  protoOf(StreamingJsonDecoder).em = function (deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.l13_1.e13_1.z14_1;
      }
      if (tmp) {
        return deserializer.gj(this);
      }
      var discriminator = classDiscriminator(deserializer.ej(), this.l13_1);
      var tmp0_elvis_lhs = this.n13_1.x1a(discriminator, this.r13_1.t14_1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp2 = isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE();
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
          var tmp_1;
          if (!(tmp2 instanceof AbstractPolymorphicSerializer)) {
            tmp_1 = true;
          } else {
            tmp_1 = this.i15().e13_1.z14_1;
          }
          if (tmp_1) {
            tmp$ret$0 = tmp2.gj(this);
            break $l$block;
          }
          var discriminator_0 = classDiscriminator(tmp2.ej(), this.i15());
          var tmp0 = this.j15();
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName = tmp2.ej().lk();
          if (!(tmp0 instanceof JsonObject)) {
            var tmp_2 = getKClass(JsonObject).o();
            var tmp_3 = getKClassFromExpression(tmp0).o();
            var tmp$ret$2 = this.n13_1.u13_1.l18();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$2, toString(tmp0));
          }
          var jsonTree = tmp0;
          var tmp0_safe_receiver = jsonTree.n15(discriminator_0);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
          var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
          var tmp_4;
          try {
            tmp_4 = findPolymorphicSerializer(tmp2, this, type);
          } catch ($p) {
            var tmp_5;
            if ($p instanceof SerializationException) {
              var it = $p;
              throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
            } else {
              throw $p;
            }
          }
          var tmp_6 = tmp_4;
          var actualSerializer = isInterface(tmp_6, DeserializationStrategy) ? tmp_6 : THROW_CCE();
          tmp$ret$0 = readPolymorphicJson(this.i15(), discriminator_0, jsonTree, actualSerializer);
        }
        return tmp$ret$0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var type_0 = tmp_0;
      var tmp_7;
      try {
        tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
      } catch ($p_0) {
        var tmp_8;
        if ($p_0 instanceof SerializationException) {
          var it_0 = $p_0;
          var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
          var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
          this.n13_1.y17(message, VOID, hint);
        } else {
          throw $p_0;
        }
        tmp_7 = tmp_8;
      }
      var tmp_9 = tmp_7;
      var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy) ? tmp_9 : THROW_CCE();
      this.q13_1 = new DiscriminatorHolder(discriminator);
      return actualSerializer_0.gj(this);
    } catch ($p_1) {
      if ($p_1 instanceof MissingFieldException) {
        var e = $p_1;
        if (contains(ensureNotNull(e.message), 'at path'))
          throw e;
        throw new MissingFieldException(e.yj_1, plus(e.message, ' at path: ') + this.n13_1.u13_1.l18(), e);
      } else {
        throw $p_1;
      }
    }
  };
  protoOf(StreamingJsonDecoder).fm = function (descriptor) {
    var newMode = switchMode(this.l13_1, descriptor);
    this.n13_1.u13_1.g18(descriptor);
    this.n13_1.p1a(newMode.a1b_1);
    checkLeadingComma(this);
    var tmp;
    switch (newMode.t2_1) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.l13_1, newMode, this.n13_1, descriptor, this.q13_1);
        break;
      default:
        var tmp_0;
        if (this.m13_1.equals(newMode) && this.l13_1.e13_1.w14_1) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.l13_1, newMode, this.n13_1, descriptor, this.q13_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).gm = function (descriptor) {
    if (descriptor.ok() === 0 && ignoreUnknownKeys(descriptor, this.l13_1)) {
      skipLeftoverElements(this, descriptor);
    }
    if (this.n13_1.q1a() && !this.l13_1.e13_1.f15_1) {
      invalidTrailingComma(this.n13_1, '');
    }
    this.n13_1.p1a(this.m13_1.b1b_1);
    this.n13_1.u13_1.k18();
  };
  protoOf(StreamingJsonDecoder).ql = function () {
    var tmp;
    var tmp0_safe_receiver = this.s13_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u17_1;
    if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
      tmp = !this.n13_1.c1b();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).rl = function () {
    return null;
  };
  protoOf(StreamingJsonDecoder).rm = function (descriptor, index, deserializer, previousValue) {
    var isMapKey = this.m13_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
    if (isMapKey) {
      this.n13_1.u13_1.j18();
    }
    var value = protoOf(AbstractDecoder).rm.call(this, descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.n13_1.u13_1.i18(value);
    }
    return value;
  };
  protoOf(StreamingJsonDecoder).wm = function (descriptor) {
    var index;
    switch (this.m13_1.t2_1) {
      case 0:
        index = decodeObjectIndex(this, descriptor);
        break;
      case 2:
        index = decodeMapIndex(this);
        break;
      default:
        index = decodeListIndex(this);
        break;
    }
    if (!this.m13_1.equals(WriteMode_MAP_getInstance())) {
      this.n13_1.u13_1.h18(index);
    }
    return index;
  };
  protoOf(StreamingJsonDecoder).sl = function () {
    return this.n13_1.d1b();
  };
  protoOf(StreamingJsonDecoder).tl = function () {
    var value = this.n13_1.e1b();
    if (!equalsLong(value, fromInt(convertToByte(value)))) {
      this.n13_1.y17("Failed to parse byte for input '" + value.toString() + "'");
    }
    return convertToByte(value);
  };
  protoOf(StreamingJsonDecoder).ul = function () {
    var value = this.n13_1.e1b();
    if (!equalsLong(value, fromInt(convertToShort(value)))) {
      this.n13_1.y17("Failed to parse short for input '" + value.toString() + "'");
    }
    return convertToShort(value);
  };
  protoOf(StreamingJsonDecoder).vl = function () {
    var value = this.n13_1.e1b();
    if (!equalsLong(value, fromInt(convertToInt(value)))) {
      this.n13_1.y17("Failed to parse int for input '" + value.toString() + "'");
    }
    return convertToInt(value);
  };
  protoOf(StreamingJsonDecoder).wl = function () {
    return this.n13_1.e1b();
  };
  protoOf(StreamingJsonDecoder).xl = function () {
    var tmp0 = this.n13_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.g19();
      try {
        // Inline function 'kotlin.text.toFloat' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y17("Failed to parse type '" + 'float' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.l13_1.e13_1.b15_1;
    if (specialFp || isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.n13_1, result);
  };
  protoOf(StreamingJsonDecoder).yl = function () {
    var tmp0 = this.n13_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.g19();
      try {
        tmp$ret$0 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y17("Failed to parse type '" + 'double' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.l13_1.e13_1.b15_1;
    if (specialFp || isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.n13_1, result);
  };
  protoOf(StreamingJsonDecoder).zl = function () {
    var string = this.n13_1.g19();
    if (!(string.length === 1)) {
      this.n13_1.y17("Expected single char, but got '" + string + "'");
    }
    return charCodeAt(string, 0);
  };
  protoOf(StreamingJsonDecoder).am = function () {
    var tmp;
    if (this.r13_1.t14_1) {
      tmp = this.n13_1.w1a();
    } else {
      tmp = this.n13_1.f19();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).cm = function (descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.n13_1, this.l13_1) : protoOf(AbstractDecoder).cm.call(this, descriptor);
  };
  protoOf(StreamingJsonDecoder).bm = function (enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.l13_1, this.am(), ' at path ' + this.n13_1.u13_1.l18());
  };
  function JsonDecoderForUnsignedTypes(lexer, json) {
    AbstractDecoder.call(this);
    this.f1b_1 = lexer;
    this.g1b_1 = json.um();
  }
  protoOf(JsonDecoderForUnsignedTypes).um = function () {
    return this.g1b_1;
  };
  protoOf(JsonDecoderForUnsignedTypes).wm = function (descriptor) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(JsonDecoderForUnsignedTypes).vl = function () {
    var tmp0 = this.f1b_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.g19();
      try {
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = toUInt(input);
        tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y17("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(JsonDecoderForUnsignedTypes).wl = function () {
    var tmp0 = this.f1b_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.g19();
      try {
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = toULong(input);
        tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y17("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(JsonDecoderForUnsignedTypes).tl = function () {
    var tmp0 = this.f1b_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.g19();
      try {
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = toUByte(input);
        tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y17("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(JsonDecoderForUnsignedTypes).ul = function () {
    var tmp0 = this.f1b_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.g19();
      try {
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = toUShort(input);
        tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.y17("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  function get_unsignedNumberDescriptors() {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return unsignedNumberDescriptors;
  }
  var unsignedNumberDescriptors;
  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
    StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
    return $this;
  }
  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
  }
  function encodeTypeInfo($this, discriminator, serialName) {
    $this.p18_1.s16();
    $this.jn(discriminator);
    $this.p18_1.v16(_Char___init__impl__6a9atx(58));
    $this.p18_1.u16();
    $this.jn(serialName);
  }
  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
    AbstractEncoder.call(this);
    this.p18_1 = composer;
    this.q18_1 = json;
    this.r18_1 = mode;
    this.s18_1 = modeReuseCache;
    this.t18_1 = this.q18_1.um();
    this.u18_1 = this.q18_1.e13_1;
    this.v18_1 = false;
    this.w18_1 = null;
    this.x18_1 = null;
    var i = this.r18_1.t2_1;
    if (!(this.s18_1 == null)) {
      if (!(this.s18_1[i] === null) || !(this.s18_1[i] === this)) {
        this.s18_1[i] = this;
      }
    }
  }
  protoOf(StreamingJsonEncoder).i15 = function () {
    return this.q18_1;
  };
  protoOf(StreamingJsonEncoder).um = function () {
    return this.t18_1;
  };
  protoOf(StreamingJsonEncoder).co = function (descriptor, index) {
    return this.u18_1.r14_1;
  };
  protoOf(StreamingJsonEncoder).xn = function (serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      if (this.i15().e13_1.z14_1) {
        serializer.fj(this, value);
        break $l$block;
      }
      var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
      var tmp;
      if (isPolymorphicSerializer) {
        tmp = !this.i15().e13_1.h15_1.equals(ClassDiscriminatorMode_NONE_getInstance());
      } else {
        var tmp_0;
        switch (this.i15().e13_1.h15_1.t2_1) {
          case 0:
          case 2:
            tmp_0 = false;
            break;
          case 1:
            // Inline function 'kotlin.let' call

            var it = serializer.ej().mk();
            tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp = tmp_0;
      }
      var needDiscriminator = tmp;
      var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.ej(), this.i15()) : null;
      var tmp_1;
      if (isPolymorphicSerializer) {
        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
        $l$block_0: {
          // Inline function 'kotlin.requireNotNull' call
          if (value == null) {
            var message = 'Value for serializer ' + toString(serializer.ej()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
            throw IllegalArgumentException_init_$Create$(toString(message));
          } else {
            break $l$block_0;
          }
        }
        var actual = findPolymorphicSerializer_0(casted, this, value);
        if (!(baseClassDiscriminator == null)) {
          access$validateIfSealed$tPolymorphicKt(serializer, actual, baseClassDiscriminator);
          checkKind_0(actual.ej().mk());
        }
        tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
      } else {
        tmp_1 = serializer;
      }
      var actualSerializer = tmp_1;
      if (!(baseClassDiscriminator == null)) {
        var serialName = actualSerializer.ej().lk();
        this.w18_1 = baseClassDiscriminator;
        this.x18_1 = serialName;
      }
      actualSerializer.fj(this, value);
    }
  };
  protoOf(StreamingJsonEncoder).fm = function (descriptor) {
    var newMode = switchMode(this.q18_1, descriptor);
    if (!(newMode.a1b_1 === _Char___init__impl__6a9atx(0))) {
      this.p18_1.v16(newMode.a1b_1);
      this.p18_1.q16();
    }
    var discriminator = this.w18_1;
    if (!(discriminator == null)) {
      var tmp0_elvis_lhs = this.x18_1;
      encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.lk() : tmp0_elvis_lhs);
      this.w18_1 = null;
      this.x18_1 = null;
    }
    if (this.r18_1.equals(newMode)) {
      return this;
    }
    var tmp1_safe_receiver = this.s18_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.t2_1];
    return tmp2_elvis_lhs == null ? new StreamingJsonEncoder(this.p18_1, this.q18_1, newMode, this.s18_1) : tmp2_elvis_lhs;
  };
  protoOf(StreamingJsonEncoder).gm = function (descriptor) {
    if (!(this.r18_1.b1b_1 === _Char___init__impl__6a9atx(0))) {
      this.p18_1.r16();
      this.p18_1.t16();
      this.p18_1.v16(this.r18_1.b1b_1);
    }
  };
  protoOf(StreamingJsonEncoder).ym = function (descriptor, index) {
    switch (this.r18_1.t2_1) {
      case 1:
        if (!this.p18_1.p16_1) {
          this.p18_1.v16(_Char___init__impl__6a9atx(44));
        }

        this.p18_1.s16();
        break;
      case 2:
        if (!this.p18_1.p16_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.p18_1.v16(_Char___init__impl__6a9atx(44));
            this.p18_1.s16();
            tmp_0 = true;
          } else {
            this.p18_1.v16(_Char___init__impl__6a9atx(58));
            this.p18_1.u16();
            tmp_0 = false;
          }
          tmp.v18_1 = tmp_0;
        } else {
          this.v18_1 = true;
          this.p18_1.s16();
        }

        break;
      case 3:
        if (index === 0)
          this.v18_1 = true;
        if (index === 1) {
          this.p18_1.v16(_Char___init__impl__6a9atx(44));
          this.p18_1.u16();
          this.v18_1 = false;
        }

        break;
      default:
        if (!this.p18_1.p16_1) {
          this.p18_1.v16(_Char___init__impl__6a9atx(44));
        }

        this.p18_1.s16();
        this.jn(getJsonElementName(descriptor, this.q18_1, index));
        this.p18_1.v16(_Char___init__impl__6a9atx(58));
        this.p18_1.u16();
        break;
    }
    return true;
  };
  protoOf(StreamingJsonEncoder).yn = function (descriptor, index, serializer, value) {
    if (!(value == null) || this.u18_1.w14_1) {
      protoOf(AbstractEncoder).yn.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(StreamingJsonEncoder).ln = function (descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.p18_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.p18_1;
      } else {
        var tmp0 = this.p18_1.o16_1;
        var p1 = this.v18_1;
        tmp_0 = new ComposerForUnsignedNumbers(tmp0, p1);
      }
      var tmp$ret$0 = tmp_0;
      tmp = new StreamingJsonEncoder(tmp$ret$0, this.q18_1, this.r18_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.p18_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.p18_1;
      } else {
        var tmp0_0 = this.p18_1.o16_1;
        var p1_0 = this.v18_1;
        tmp_2 = new ComposerForUnquotedLiterals(tmp0_0, p1_0);
      }
      var tmp$ret$2 = tmp_2;
      tmp = new StreamingJsonEncoder(tmp$ret$2, this.q18_1, this.r18_1, null);
    } else if (!(this.w18_1 == null)) {
      // Inline function 'kotlin.apply' call
      this.x18_1 = descriptor.lk();
      tmp = this;
    } else {
      tmp = protoOf(AbstractEncoder).ln.call(this, descriptor);
    }
    return tmp;
  };
  protoOf(StreamingJsonEncoder).an = function () {
    this.p18_1.x16('null');
  };
  protoOf(StreamingJsonEncoder).bn = function (value) {
    if (this.v18_1) {
      this.jn(value.toString());
    } else {
      this.p18_1.g17(value);
    }
  };
  protoOf(StreamingJsonEncoder).cn = function (value) {
    if (this.v18_1) {
      this.jn(value.toString());
    } else {
      this.p18_1.b17(value);
    }
  };
  protoOf(StreamingJsonEncoder).dn = function (value) {
    if (this.v18_1) {
      this.jn(value.toString());
    } else {
      this.p18_1.d17(value);
    }
  };
  protoOf(StreamingJsonEncoder).en = function (value) {
    if (this.v18_1) {
      this.jn(value.toString());
    } else {
      this.p18_1.e17(value);
    }
  };
  protoOf(StreamingJsonEncoder).fn = function (value) {
    if (this.v18_1) {
      this.jn(value.toString());
    } else {
      this.p18_1.f17(value);
    }
  };
  protoOf(StreamingJsonEncoder).gn = function (value) {
    if (this.v18_1) {
      this.jn(value.toString());
    } else {
      this.p18_1.z16(value);
    }
    if (!this.u18_1.b15_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.p18_1.o16_1));
    }
  };
  protoOf(StreamingJsonEncoder).hn = function (value) {
    if (this.v18_1) {
      this.jn(value.toString());
    } else {
      this.p18_1.a17(value);
    }
    if (!this.u18_1.b15_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.p18_1.o16_1));
    }
  };
  protoOf(StreamingJsonEncoder).in = function (value) {
    this.jn(toString_1(value));
  };
  protoOf(StreamingJsonEncoder).jn = function (value) {
    return this.p18_1.h17(value);
  };
  protoOf(StreamingJsonEncoder).kn = function (enumDescriptor, index) {
    this.jn(enumDescriptor.qk(index));
  };
  function get_isUnsignedNumber(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.nk() && get_unsignedNumberDescriptors().c2(_this__u8e3s4);
  }
  function get_isUnquotedLiteral(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.nk() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
  }
  var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
  function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
    if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
      properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
      unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).ej(), serializer_0(Companion_getInstance()).ej(), serializer_2(Companion_getInstance_1()).ej(), serializer_3(Companion_getInstance_2()).ej()]);
    }
  }
  function get_ESCAPE_STRINGS() {
    _init_properties_StringOps_kt__fcy1db();
    return ESCAPE_STRINGS;
  }
  var ESCAPE_STRINGS;
  var ESCAPE_MARKERS;
  function toHexChar(i) {
    _init_properties_StringOps_kt__fcy1db();
    var d = i & 15;
    var tmp;
    if (d < 10) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      tmp = numberToChar(d + tmp$ret$0 | 0);
    } else {
      var tmp_0 = d - 10 | 0;
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
    }
    return tmp;
  }
  function printQuoted(_this__u8e3s4, value) {
    _init_properties_StringOps_kt__fcy1db();
    _this__u8e3s4.s(_Char___init__impl__6a9atx(34));
    var lastPos = 0;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(value, i);
        var c = Char__toInt_impl_vasixd(this_0);
        if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
          _this__u8e3s4.na(value, lastPos, i);
          _this__u8e3s4.q(get_ESCAPE_STRINGS()[c]);
          lastPos = i + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    if (!(lastPos === 0))
      _this__u8e3s4.na(value, lastPos, value.length);
    else
      _this__u8e3s4.q(value);
    _this__u8e3s4.s(_Char___init__impl__6a9atx(34));
  }
  function toBooleanStrictOrNull_0(_this__u8e3s4) {
    _init_properties_StringOps_kt__fcy1db();
    return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
  }
  var properties_initialized_StringOps_kt_wzaea7;
  function _init_properties_StringOps_kt__fcy1db() {
    if (!properties_initialized_StringOps_kt_wzaea7) {
      properties_initialized_StringOps_kt_wzaea7 = true;
      // Inline function 'kotlin.arrayOfNulls' call
      // Inline function 'kotlin.apply' call
      var this_0 = Array(93);
      var inductionVariable = 0;
      if (inductionVariable <= 31)
        do {
          var c = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var c1 = toHexChar(c >> 12);
          var c2 = toHexChar(c >> 8);
          var c3 = toHexChar(c >> 4);
          var c4 = toHexChar(c);
          this_0[c] = '\\u' + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
        }
         while (inductionVariable <= 31);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(34);
      this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(92);
      this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(9);
      this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(8);
      this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(10);
      this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
      // Inline function 'kotlin.code' call
      var this_6 = _Char___init__impl__6a9atx(13);
      this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
      this_0[12] = '\\f';
      ESCAPE_STRINGS = this_0;
      // Inline function 'kotlin.apply' call
      var this_7 = new Int8Array(93);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 31)
        do {
          var c_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_7[c_0] = 1;
        }
         while (inductionVariable_0 <= 31);
      // Inline function 'kotlin.code' call
      var this_8 = _Char___init__impl__6a9atx(34);
      var tmp = Char__toInt_impl_vasixd(this_8);
      // Inline function 'kotlin.code' call
      var this_9 = _Char___init__impl__6a9atx(34);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_9);
      this_7[tmp] = toByte(tmp$ret$3);
      // Inline function 'kotlin.code' call
      var this_10 = _Char___init__impl__6a9atx(92);
      var tmp_0 = Char__toInt_impl_vasixd(this_10);
      // Inline function 'kotlin.code' call
      var this_11 = _Char___init__impl__6a9atx(92);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_11);
      this_7[tmp_0] = toByte(tmp$ret$5);
      // Inline function 'kotlin.code' call
      var this_12 = _Char___init__impl__6a9atx(9);
      var tmp_1 = Char__toInt_impl_vasixd(this_12);
      // Inline function 'kotlin.code' call
      var this_13 = _Char___init__impl__6a9atx(116);
      var tmp$ret$7 = Char__toInt_impl_vasixd(this_13);
      this_7[tmp_1] = toByte(tmp$ret$7);
      // Inline function 'kotlin.code' call
      var this_14 = _Char___init__impl__6a9atx(8);
      var tmp_2 = Char__toInt_impl_vasixd(this_14);
      // Inline function 'kotlin.code' call
      var this_15 = _Char___init__impl__6a9atx(98);
      var tmp$ret$9 = Char__toInt_impl_vasixd(this_15);
      this_7[tmp_2] = toByte(tmp$ret$9);
      // Inline function 'kotlin.code' call
      var this_16 = _Char___init__impl__6a9atx(10);
      var tmp_3 = Char__toInt_impl_vasixd(this_16);
      // Inline function 'kotlin.code' call
      var this_17 = _Char___init__impl__6a9atx(110);
      var tmp$ret$11 = Char__toInt_impl_vasixd(this_17);
      this_7[tmp_3] = toByte(tmp$ret$11);
      // Inline function 'kotlin.code' call
      var this_18 = _Char___init__impl__6a9atx(13);
      var tmp_4 = Char__toInt_impl_vasixd(this_18);
      // Inline function 'kotlin.code' call
      var this_19 = _Char___init__impl__6a9atx(114);
      var tmp$ret$13 = Char__toInt_impl_vasixd(this_19);
      this_7[tmp_4] = toByte(tmp$ret$13);
      // Inline function 'kotlin.code' call
      var this_20 = _Char___init__impl__6a9atx(102);
      var tmp$ret$14 = Char__toInt_impl_vasixd(this_20);
      this_7[12] = toByte(tmp$ret$14);
      ESCAPE_MARKERS = this_7;
    }
  }
  function unparsedPrimitive($this, literal, primitive, tag) {
    var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
    throw JsonDecodingException_0(-1, "Failed to parse literal '" + literal.toString() + "' as " + type + ' value at element: ' + $this.n1b(tag), toString($this.o1b()));
  }
  function AbstractJsonTreeDecoder(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    NamedValueDecoder.call(this);
    this.j1b_1 = json;
    this.k1b_1 = value;
    this.l1b_1 = polymorphicDiscriminator;
    this.m1b_1 = this.i15().e13_1;
  }
  protoOf(AbstractJsonTreeDecoder).i15 = function () {
    return this.j1b_1;
  };
  protoOf(AbstractJsonTreeDecoder).f2 = function () {
    return this.k1b_1;
  };
  protoOf(AbstractJsonTreeDecoder).um = function () {
    return this.i15().um();
  };
  protoOf(AbstractJsonTreeDecoder).o1b = function () {
    var tmp0_safe_receiver = this.l10();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = this.p1b(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? this.f2() : tmp1_elvis_lhs;
  };
  protoOf(AbstractJsonTreeDecoder).n1b = function (currentTag) {
    return this.n10() + ('.' + currentTag);
  };
  protoOf(AbstractJsonTreeDecoder).j15 = function () {
    return this.o1b();
  };
  protoOf(AbstractJsonTreeDecoder).em = function (deserializer) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.i15().e13_1.z14_1;
      }
      if (tmp) {
        tmp$ret$0 = deserializer.gj(this);
        break $l$block;
      }
      var discriminator = classDiscriminator(deserializer.ej(), this.i15());
      var tmp0 = this.j15();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = deserializer.ej().lk();
      if (!(tmp0 instanceof JsonObject)) {
        var tmp_0 = getKClass(JsonObject).o();
        var tmp_1 = getKClassFromExpression(tmp0).o();
        var tmp$ret$2 = this.n10();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$2, toString(tmp0));
      }
      var jsonTree = tmp0;
      var tmp0_safe_receiver = jsonTree.n15(discriminator);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
      var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
      var tmp_2;
      try {
        tmp_2 = findPolymorphicSerializer(deserializer, this, type);
      } catch ($p) {
        var tmp_3;
        if ($p instanceof SerializationException) {
          var it = $p;
          throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
        } else {
          throw $p;
        }
      }
      var tmp_4 = tmp_2;
      var actualSerializer = isInterface(tmp_4, DeserializationStrategy) ? tmp_4 : THROW_CCE();
      tmp$ret$0 = readPolymorphicJson(this.i15(), discriminator, jsonTree, actualSerializer);
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).m10 = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeDecoder).fm = function (descriptor) {
    var currentObject = this.o1b();
    var tmp0_subject = descriptor.mk();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.i15();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = descriptor.lk();
      if (!(currentObject instanceof JsonArray)) {
        var tmp_2 = getKClass(JsonArray).o();
        var tmp_3 = getKClassFromExpression(currentObject).o();
        var tmp$ret$2 = this.n10();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$2, toString(currentObject));
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.i15();
        var keyDescriptor = carrierDescriptor(descriptor.tk(0), this_0.um());
        var keyKind = keyDescriptor.mk();
        var tmp_4;
        var tmp_5;
        if (keyKind instanceof PrimitiveKind) {
          tmp_5 = true;
        } else {
          tmp_5 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_5) {
          var tmp_6 = this.i15();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName_0 = descriptor.lk();
          if (!(currentObject instanceof JsonObject)) {
            var tmp_7 = getKClass(JsonObject).o();
            var tmp_8 = getKClassFromExpression(currentObject).o();
            var tmp$ret$7 = this.n10();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_7 + ', but had ' + tmp_8 + ' as the serialized body of ' + serialName_0 + ' at element: ' + tmp$ret$7, toString(currentObject));
          }
          tmp_4 = new JsonTreeMapDecoder(tmp_6, currentObject);
        } else {
          if (this_0.e13_1.u14_1) {
            var tmp_9 = this.i15();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var serialName_1 = descriptor.lk();
            if (!(currentObject instanceof JsonArray)) {
              var tmp_10 = getKClass(JsonArray).o();
              var tmp_11 = getKClassFromExpression(currentObject).o();
              var tmp$ret$11 = this.n10();
              throw JsonDecodingException_0(-1, 'Expected ' + tmp_10 + ', but had ' + tmp_11 + ' as the serialized body of ' + serialName_1 + ' at element: ' + tmp$ret$11, toString(currentObject));
            }
            tmp_4 = new JsonTreeListDecoder(tmp_9, currentObject);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_4;
      } else {
        var tmp_12 = this.i15();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName_2 = descriptor.lk();
        if (!(currentObject instanceof JsonObject)) {
          var tmp_13 = getKClass(JsonObject).o();
          var tmp_14 = getKClassFromExpression(currentObject).o();
          var tmp$ret$14 = this.n10();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_13 + ', but had ' + tmp_14 + ' as the serialized body of ' + serialName_2 + ' at element: ' + tmp$ret$14, toString(currentObject));
        }
        tmp = new JsonTreeDecoder(tmp_12, currentObject, this.l1b_1);
      }
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).gm = function (descriptor) {
  };
  protoOf(AbstractJsonTreeDecoder).ql = function () {
    var tmp = this.o1b();
    return !(tmp instanceof JsonNull);
  };
  protoOf(AbstractJsonTreeDecoder).q1b = function (tag, enumDescriptor) {
    var tmp = this.i15();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    var tmp2 = this.p1b(tag);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = enumDescriptor.lk();
    if (!(tmp2 instanceof JsonPrimitive)) {
      var tmp_0 = getKClass(JsonPrimitive).o();
      var tmp_1 = getKClassFromExpression(tmp2).o();
      var tmp$ret$3 = this.n1b(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$3, toString(tmp2));
    }
    return getJsonNameIndexOrThrow(enumDescriptor, tmp, tmp2.k15());
  };
  protoOf(AbstractJsonTreeDecoder).z10 = function (tag, enumDescriptor) {
    return this.q1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).r1b = function (tag) {
    return !(this.p1b(tag) === JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeDecoder).p10 = function (tag) {
    return this.r1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).s1b = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.p1b(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).o();
        var tmp_0 = getKClassFromExpression(value).o();
        var tmp$ret$3 = this.n1b(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'boolean' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_booleanOrNull(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).q10 = function (tag) {
    return this.s1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).t1b = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.p1b(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).o();
        var tmp_0 = getKClassFromExpression(value).o();
        var tmp$ret$3 = this.n1b(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'byte' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var result = parseLongImpl(literal);
        var tmp_1;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-128, 127);
        if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
          tmp_1 = convertToByte(result);
        } else {
          tmp_1 = null;
        }
        var tmp0_elvis_lhs = tmp_1;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_2;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).r10 = function (tag) {
    return this.t1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).u1b = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.p1b(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).o();
        var tmp_0 = getKClassFromExpression(value).o();
        var tmp$ret$3 = this.n1b(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'short' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var result = parseLongImpl(literal);
        var tmp_1;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-32768, 32767);
        if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
          tmp_1 = convertToShort(result);
        } else {
          tmp_1 = null;
        }
        var tmp0_elvis_lhs = tmp_1;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_2;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).s10 = function (tag) {
    return this.u1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).v1b = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.p1b(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).o();
        var tmp_0 = getKClassFromExpression(value).o();
        var tmp$ret$3 = this.n1b(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'int' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var result = parseLongImpl(literal);
        var tmp_1;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-2147483648, 2147483647);
        if (contains_0(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
          tmp_1 = convertToInt(result);
        } else {
          tmp_1 = null;
        }
        var tmp0_elvis_lhs = tmp_1;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_2;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).t10 = function (tag) {
    return this.v1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).w1b = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.p1b(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).o();
        var tmp_0 = getKClassFromExpression(value).o();
        var tmp$ret$3 = this.n1b(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'long' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = parseLongImpl(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).u10 = function (tag) {
    return this.w1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).x1b = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.p1b(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).o();
        var tmp_0 = getKClassFromExpression(value).o();
        var tmp$ret$3 = this.n1b(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'float' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_float(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.i15().e13_1.b15_1;
    if (specialFp || isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.o1b()));
  };
  protoOf(AbstractJsonTreeDecoder).v10 = function (tag) {
    return this.x1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).y1b = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.p1b(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).o();
        var tmp_0 = getKClassFromExpression(value).o();
        var tmp$ret$3 = this.n1b(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'double' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_double(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$0;
    var specialFp = this.i15().e13_1.b15_1;
    if (specialFp || isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.o1b()));
  };
  protoOf(AbstractJsonTreeDecoder).w10 = function (tag) {
    return this.y1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).z1b = function (tag) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.p1b(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).o();
        var tmp_0 = getKClassFromExpression(value).o();
        var tmp$ret$3 = this.n1b(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'char' + ' at element: ' + tmp$ret$3, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = new Char(single(literal.k15()));
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp_1.q1_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).x10 = function (tag) {
    return this.z1b((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).a1c = function (tag) {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.p1b(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).o();
      var tmp_0 = getKClassFromExpression(value).o();
      var tmp$ret$2 = this.n1b(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'string' + ' at element: ' + tmp$ret$2, toString(value));
    }
    var value_0 = value;
    if (!(value_0 instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, "Expected string value for a non-null key '" + tag + "', got null literal instead at element: " + this.n1b(tag), toString(this.o1b()));
    if (!value_0.r15_1 && !this.i15().e13_1.t14_1) {
      throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted at element: " + this.n1b(tag) + ".\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString(this.o1b()));
    }
    return value_0.t15_1;
  };
  protoOf(AbstractJsonTreeDecoder).y10 = function (tag) {
    return this.a1c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).b1c = function (tag, inlineDescriptor) {
    var tmp;
    if (get_isUnsignedNumber(inlineDescriptor)) {
      var tmp_0 = this.i15();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      var tmp2 = this.p1b(tag);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = inlineDescriptor.lk();
      if (!(tmp2 instanceof JsonPrimitive)) {
        var tmp_1 = getKClass(JsonPrimitive).o();
        var tmp_2 = getKClassFromExpression(tmp2).o();
        var tmp$ret$3 = this.n1b(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_1 + ', but had ' + tmp_2 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$3, toString(tmp2));
      }
      var lexer = StringJsonLexer_0(tmp_0, tmp2.k15());
      tmp = new JsonDecoderForUnsignedTypes(lexer, this.i15());
    } else {
      tmp = protoOf(NamedValueDecoder).a11.call(this, tag, inlineDescriptor);
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).a11 = function (tag, inlineDescriptor) {
    return this.b1c((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).cm = function (descriptor) {
    return !(this.l10() == null) ? protoOf(NamedValueDecoder).cm.call(this, descriptor) : (new JsonPrimitiveDecoder(this.i15(), this.f2(), this.l1b_1)).cm(descriptor);
  };
  function coerceInputValue_0($this, descriptor, index, tag) {
    var tmp0 = $this.i15();
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var isOptional = descriptor.uk(index);
      var elementDescriptor = descriptor.tk(index);
      var tmp;
      if (isOptional && !elementDescriptor.ek()) {
        var tmp_0 = $this.p1b(tag);
        tmp = tmp_0 instanceof JsonNull;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_2;
      }
      if (equals(elementDescriptor.mk(), ENUM_getInstance())) {
        var tmp_1;
        if (elementDescriptor.ek()) {
          var tmp_2 = $this.p1b(tag);
          tmp_1 = tmp_2 instanceof JsonNull;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$0 = false;
          break $l$block_2;
        }
        var tmp_3 = $this.p1b(tag);
        var tmp0_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
        var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
        var tmp_4;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$0 = false;
          break $l$block_2;
        } else {
          tmp_4 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_4;
        var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
        var coerceToNull = !tmp0.e13_1.w14_1 && elementDescriptor.ek();
        if (enumIndex === -3 && (isOptional || coerceToNull)) {
          tmp$ret$0 = true;
          break $l$block_2;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function absenceIsNull($this, descriptor, index) {
    $this.l1c_1 = (!$this.i15().e13_1.w14_1 && !descriptor.uk(index) && descriptor.tk(index).ek());
    return $this.l1c_1;
  }
  function JsonTreeDecoder(json, value, polymorphicDiscriminator, polyDescriptor) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
    this.i1c_1 = value;
    this.j1c_1 = polyDescriptor;
    this.k1c_1 = 0;
    this.l1c_1 = false;
  }
  protoOf(JsonTreeDecoder).f2 = function () {
    return this.i1c_1;
  };
  protoOf(JsonTreeDecoder).wm = function (descriptor) {
    while (this.k1c_1 < descriptor.ok()) {
      var _unary__edvuaz = this.k1c_1;
      this.k1c_1 = _unary__edvuaz + 1 | 0;
      var name = this.g10(descriptor, _unary__edvuaz);
      var index = this.k1c_1 - 1 | 0;
      this.l1c_1 = false;
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = this.f2();
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).g2(name)) {
        tmp_0 = true;
      } else {
        tmp_0 = absenceIsNull(this, descriptor, index);
      }
      if (tmp_0) {
        tmp = !this.m1b_1.y14_1 || !coerceInputValue_0(this, descriptor, index, name);
      } else {
        tmp = false;
      }
      if (tmp) {
        return index;
      }
    }
    return -1;
  };
  protoOf(JsonTreeDecoder).ql = function () {
    return !this.l1c_1 && protoOf(AbstractJsonTreeDecoder).ql.call(this);
  };
  protoOf(JsonTreeDecoder).h10 = function (descriptor, index) {
    var strategy = namingStrategy(descriptor, this.i15());
    var baseName = descriptor.qk(index);
    if (strategy == null) {
      if (!this.m1b_1.c15_1)
        return baseName;
      if (this.f2().j2().c2(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.i15(), descriptor);
    // Inline function 'kotlin.collections.find' call
    var tmp0 = this.f2().j2();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (deserializationNamesMap_0.i2(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.c18(descriptor, index, baseName);
    return fallbackName == null ? baseName : fallbackName;
  };
  protoOf(JsonTreeDecoder).p1b = function (tag) {
    return getValue(this.f2(), tag);
  };
  protoOf(JsonTreeDecoder).fm = function (descriptor) {
    if (descriptor === this.j1c_1) {
      var tmp = this.i15();
      var tmp2 = this.o1b();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = this.j1c_1.lk();
      if (!(tmp2 instanceof JsonObject)) {
        var tmp_0 = getKClass(JsonObject).o();
        var tmp_1 = getKClassFromExpression(tmp2).o();
        var tmp$ret$2 = this.n10();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$2, toString(tmp2));
      }
      return new JsonTreeDecoder(tmp, tmp2, this.l1b_1, this.j1c_1);
    }
    return protoOf(AbstractJsonTreeDecoder).fm.call(this, descriptor);
  };
  protoOf(JsonTreeDecoder).gm = function (descriptor) {
    var tmp;
    if (ignoreUnknownKeys(descriptor, this.i15())) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.mk();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_instance;
    var strategy = namingStrategy(descriptor, this.i15());
    var tmp_1;
    if (strategy == null && !this.m1b_1.c15_1) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.i15(), descriptor).j2();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      var tmp0_safe_receiver = get_schemaCache(this.i15()).n1a(descriptor, get_JsonDeserializationNamesKey());
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j2();
      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_0(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var _iterator__ex2g4s = this.f2().j2().t();
    while (_iterator__ex2g4s.u()) {
      var key = _iterator__ex2g4s.v();
      if (!names.c2(key) && !(key === this.l1b_1)) {
        throw JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "' at element: " + this.n10() + '\n' + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.\n" + ('JSON input: ' + toString(minify(this.f2().toString()))));
      }
    }
  };
  function JsonTreeListDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.s1c_1 = value;
    this.t1c_1 = this.s1c_1.z();
    this.u1c_1 = -1;
  }
  protoOf(JsonTreeListDecoder).f2 = function () {
    return this.s1c_1;
  };
  protoOf(JsonTreeListDecoder).h10 = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListDecoder).p1b = function (tag) {
    return this.s1c_1.a1(toInt(tag));
  };
  protoOf(JsonTreeListDecoder).wm = function (descriptor) {
    while (this.u1c_1 < (this.t1c_1 - 1 | 0)) {
      this.u1c_1 = this.u1c_1 + 1 | 0;
      return this.u1c_1;
    }
    return -1;
  };
  function JsonPrimitiveDecoder(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
    this.b1d_1 = value;
    this.b11('primitive');
  }
  protoOf(JsonPrimitiveDecoder).f2 = function () {
    return this.b1d_1;
  };
  protoOf(JsonPrimitiveDecoder).wm = function (descriptor) {
    return 0;
  };
  protoOf(JsonPrimitiveDecoder).p1b = function (tag) {
    // Inline function 'kotlin.require' call
    if (!(tag === 'primitive')) {
      var message = "This input can only handle primitives with 'primitive' tag";
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.b1d_1;
  };
  function JsonTreeMapDecoder(json, value) {
    JsonTreeDecoder.call(this, json, value);
    this.m1d_1 = value;
    this.n1d_1 = toList(this.m1d_1.j2());
    this.o1d_1 = imul(this.n1d_1.z(), 2);
    this.p1d_1 = -1;
  }
  protoOf(JsonTreeMapDecoder).f2 = function () {
    return this.m1d_1;
  };
  protoOf(JsonTreeMapDecoder).h10 = function (descriptor, index) {
    var i = index / 2 | 0;
    return this.n1d_1.a1(i);
  };
  protoOf(JsonTreeMapDecoder).wm = function (descriptor) {
    while (this.p1d_1 < (this.o1d_1 - 1 | 0)) {
      this.p1d_1 = this.p1d_1 + 1 | 0;
      return this.p1d_1;
    }
    return -1;
  };
  protoOf(JsonTreeMapDecoder).p1b = function (tag) {
    return (this.p1d_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.m1d_1, tag);
  };
  protoOf(JsonTreeMapDecoder).gm = function (descriptor) {
  };
  function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
    return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.ej())).em(deserializer);
  }
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  function values() {
    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_instance;
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
    WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  }
  var $ENTRIES;
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this.a1b_1 = begin;
    this.b1b_1 = end;
  }
  function switchMode(_this__u8e3s4, desc) {
    var tmp0_subject = desc.mk();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
          var keyDescriptor = carrierDescriptor(desc.tk(0), _this__u8e3s4.um());
          var keyKind = keyDescriptor.mk();
          var tmp_0;
          var tmp_1;
          if (keyKind instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            tmp_1 = equals(keyKind, ENUM_getInstance());
          }
          if (tmp_1) {
            tmp_0 = WriteMode_MAP_getInstance();
          } else {
            if (_this__u8e3s4.e13_1.u14_1) {
              tmp_0 = WriteMode_LIST_getInstance();
            } else {
              throw InvalidKeyKindException(keyDescriptor);
            }
          }
          tmp = tmp_0;
        } else {
          tmp = WriteMode_OBJ_getInstance();
        }
      }
    }
    return tmp;
  }
  function carrierDescriptor(_this__u8e3s4, module_0) {
    var tmp;
    if (equals(_this__u8e3s4.mk(), CONTEXTUAL_getInstance())) {
      var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
      tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    } else if (_this__u8e3s4.nk()) {
      tmp = carrierDescriptor(_this__u8e3s4.tk(0), module_0);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  function appendEscape($this, lastPosition, current) {
    $this.q1d(lastPosition, current);
    return appendEsc($this, current + 1 | 0);
  }
  function decodedString($this, lastPosition, currentPosition) {
    $this.q1d(lastPosition, currentPosition);
    var result = $this.w13_1.toString();
    $this.w13_1.sa(0);
    return result;
  }
  function takePeeked($this) {
    // Inline function 'kotlin.also' call
    var this_0 = ensureNotNull($this.v13_1);
    $this.v13_1 = null;
    return this_0;
  }
  function wasUnquotedString($this) {
    return !(charSequenceGet($this.r1d(), $this.t13_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
  }
  function appendEsc($this, startPosition) {
    var currentPosition = startPosition;
    currentPosition = $this.s1d(currentPosition);
    if (currentPosition === -1) {
      $this.y17('Expected escape sequence to continue, got EOF');
    }
    var tmp = $this.r1d();
    var _unary__edvuaz = currentPosition;
    currentPosition = _unary__edvuaz + 1 | 0;
    var currentChar = charSequenceGet(tmp, _unary__edvuaz);
    if (currentChar === _Char___init__impl__6a9atx(117)) {
      return appendHex($this, $this.r1d(), currentPosition);
    }
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
    var c = escapeToChar(tmp$ret$0);
    if (c === _Char___init__impl__6a9atx(0)) {
      $this.y17("Invalid escaped char '" + toString_1(currentChar) + "'");
    }
    $this.w13_1.s(c);
    return currentPosition;
  }
  function appendHex($this, source, startPos) {
    if ((startPos + 4 | 0) >= charSequenceLength(source)) {
      $this.t13_1 = startPos;
      $this.t1d();
      if (($this.t13_1 + 4 | 0) >= charSequenceLength(source)) {
        $this.y17('Unexpected EOF during unicode escape');
      }
      return appendHex($this, source, $this.t13_1);
    }
    $this.w13_1.s(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
    return startPos + 4 | 0;
  }
  function fromHexChar($this, source, currentPosition) {
    var character = charSequenceGet(source, currentPosition);
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
      // Inline function 'kotlin.code' call
      var tmp_0 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
    } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
      // Inline function 'kotlin.code' call
      var tmp_1 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
      // Inline function 'kotlin.code' call
      var tmp_2 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
    } else {
      $this.y17("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
    }
    return tmp;
  }
  function consumeBoolean2($this, start) {
    var current = $this.s1d(start);
    if (current >= charSequenceLength($this.r1d()) || current === -1) {
      $this.y17('EOF');
    }
    var tmp = $this.r1d();
    var _unary__edvuaz = current;
    current = _unary__edvuaz + 1 | 0;
    // Inline function 'kotlin.code' call
    var this_0 = charSequenceGet(tmp, _unary__edvuaz);
    var tmp0_subject = Char__toInt_impl_vasixd(this_0) | 32;
    var tmp_0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(116);
    if (tmp0_subject === Char__toInt_impl_vasixd(this_1)) {
      consumeBooleanLiteral($this, 'rue', current);
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(102);
      if (tmp0_subject === Char__toInt_impl_vasixd(this_2)) {
        consumeBooleanLiteral($this, 'alse', current);
        tmp_0 = false;
      } else {
        $this.y17("Expected valid boolean literal prefix, but had '" + $this.g19() + "'");
      }
    }
    return tmp_0;
  }
  function consumeBooleanLiteral($this, literalSuffix, current) {
    if ((charSequenceLength($this.r1d()) - current | 0) < literalSuffix.length) {
      $this.y17('Unexpected end of boolean literal');
    }
    var inductionVariable = 0;
    var last = charSequenceLength(literalSuffix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var expected = charCodeAt(literalSuffix, i);
        var actual = charSequenceGet($this.r1d(), current + i | 0);
        // Inline function 'kotlin.code' call
        var tmp = Char__toInt_impl_vasixd(expected);
        // Inline function 'kotlin.code' call
        if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
          $this.y17("Expected valid boolean literal prefix, but had '" + $this.g19() + "'");
        }
      }
       while (inductionVariable <= last);
    $this.t13_1 = current + literalSuffix.length | 0;
  }
  function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
    var tmp;
    switch (isExponentPositive) {
      case false:
        // Inline function 'kotlin.math.pow' call

        var x = -toNumber(exponentAccumulator);
        tmp = Math.pow(10.0, x);
        break;
      case true:
        // Inline function 'kotlin.math.pow' call

        var x_0 = toNumber(exponentAccumulator);
        tmp = Math.pow(10.0, x_0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function AbstractJsonLexer() {
    this.t13_1 = 0;
    this.u13_1 = new JsonPath();
    this.v13_1 = null;
    this.w13_1 = StringBuilder_init_$Create$();
  }
  protoOf(AbstractJsonLexer).t1d = function () {
  };
  protoOf(AbstractJsonLexer).q1a = function () {
    var current = this.u1d();
    var source = this.r1d();
    if (current >= charSequenceLength(source) || current === -1)
      return false;
    if (charSequenceGet(source, current) === _Char___init__impl__6a9atx(44)) {
      this.t13_1 = this.t13_1 + 1 | 0;
      return true;
    }
    return false;
  };
  protoOf(AbstractJsonLexer).v1d = function (c) {
    return c === _Char___init__impl__6a9atx(125) || c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(58) || c === _Char___init__impl__6a9atx(44)) ? false : true;
  };
  protoOf(AbstractJsonLexer).x13 = function () {
    var nextToken = this.i19();
    if (!(nextToken === 10)) {
      this.y17('Expected EOF after parsing, but had ' + toString_1(charSequenceGet(this.r1d(), this.t13_1 - 1 | 0)) + ' instead');
    }
  };
  protoOf(AbstractJsonLexer).c19 = function (expected) {
    var token = this.i19();
    if (!(token === expected)) {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
      var expected_0 = tokenDescription(expected);
      var position = true ? this.t13_1 - 1 | 0 : this.t13_1;
      var s = this.t13_1 === charSequenceLength(this.r1d()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.r1d(), position));
      var tmp$ret$1 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
      this.y17(tmp$ret$1, position);
    }
    return token;
  };
  protoOf(AbstractJsonLexer).w1d = function (expected) {
    if (this.t13_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
        var snapshot = this.t13_1;
        try {
          this.t13_1 = this.t13_1 - 1 | 0;
          tmp$ret$0 = this.g19();
          break $l$block;
        }finally {
          this.t13_1 = snapshot;
        }
      }
      var inputLiteral = tmp$ret$0;
      if (inputLiteral === 'null') {
        this.x17("Expected string literal but 'null' literal was found", this.t13_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
      }
    }
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
    var expectedToken = charToTokenClass(expected);
    var expected_0 = tokenDescription(expectedToken);
    var position = true ? this.t13_1 - 1 | 0 : this.t13_1;
    var s = this.t13_1 === charSequenceLength(this.r1d()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.r1d(), position));
    var tmp$ret$3 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
    this.y17(tmp$ret$3, position);
  };
  protoOf(AbstractJsonLexer).d19 = function () {
    var source = this.r1d();
    var cpos = this.t13_1;
    $l$loop_0: while (true) {
      cpos = this.s1d(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.t13_1 = cpos;
      return charToTokenClass(ch);
    }
    this.t13_1 = cpos;
    return 10;
  };
  protoOf(AbstractJsonLexer).r1a = function (doConsume) {
    var current = this.u1d();
    current = this.s1d(current);
    var len = charSequenceLength(this.r1d()) - current | 0;
    if (len < 4 || current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charCodeAt('null', i) === charSequenceGet(this.r1d(), current + i | 0)))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 && charToTokenClass(charSequenceGet(this.r1d(), current + 4 | 0)) === 0)
      return false;
    if (doConsume) {
      this.t13_1 = current + 4 | 0;
    }
    return true;
  };
  protoOf(AbstractJsonLexer).c1b = function (doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.r1a(doConsume) : $super.r1a.call(this, doConsume);
  };
  protoOf(AbstractJsonLexer).s1a = function (isLenient) {
    var token = this.d19();
    var tmp;
    if (isLenient) {
      if (!(token === 1) && !(token === 0))
        return null;
      tmp = this.g19();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.f19();
    }
    var string = tmp;
    this.v13_1 = string;
    return string;
  };
  protoOf(AbstractJsonLexer).x1d = function () {
    this.v13_1 = null;
  };
  protoOf(AbstractJsonLexer).y1d = function (startPos, endPos) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.r1d();
    return toString(charSequenceSubSequence(this_0, startPos, endPos));
  };
  protoOf(AbstractJsonLexer).f19 = function () {
    if (!(this.v13_1 == null)) {
      return takePeeked(this);
    }
    return this.v1a();
  };
  protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!(char === _Char___init__impl__6a9atx(34))) {
      if (char === _Char___init__impl__6a9atx(92)) {
        usedAppend = true;
        currentPosition = this.s1d(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.y17('Unexpected EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.q1d(lastPosition, currentPosition);
          currentPosition = this.s1d(currentPosition);
          if (currentPosition === -1) {
            this.y17('Unexpected EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.y1d(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.t13_1 = currentPosition + 1 | 0;
    return string;
  };
  protoOf(AbstractJsonLexer).w1a = function () {
    var result = this.g19();
    if (result === 'null' && wasUnquotedString(this)) {
      this.y17("Unexpected 'null' value instead of string literal");
    }
    return result;
  };
  protoOf(AbstractJsonLexer).g19 = function () {
    if (!(this.v13_1 == null)) {
      return takePeeked(this);
    }
    var current = this.u1d();
    if (current >= charSequenceLength(this.r1d()) || current === -1) {
      this.y17('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.r1d(), current));
    if (token === 1) {
      return this.f19();
    }
    if (!(token === 0)) {
      this.y17('Expected beginning of the string, but got ' + toString_1(charSequenceGet(this.r1d(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.r1d(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.r1d())) {
        usedAppend = true;
        this.q1d(this.t13_1, current);
        var eof = this.s1d(current);
        if (eof === -1) {
          this.t13_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.y1d(this.t13_1, current);
    } else {
      tmp = decodedString(this, this.t13_1, current);
    }
    var result = tmp;
    this.t13_1 = current;
    return result;
  };
  protoOf(AbstractJsonLexer).q1d = function (fromIndex, toIndex) {
    this.w13_1.na(this.r1d(), fromIndex, toIndex);
  };
  protoOf(AbstractJsonLexer).u1a = function (allowLenientStrings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tokenStack = ArrayList_init_$Create$();
    var lastToken = this.d19();
    if (!(lastToken === 8) && !(lastToken === 6)) {
      this.g19();
      return Unit_instance;
    }
    $l$loop: while (true) {
      lastToken = this.d19();
      if (lastToken === 1) {
        if (allowLenientStrings)
          this.g19();
        else
          this.v1a();
        continue $l$loop;
      }
      var tmp0_subject = lastToken;
      if (tmp0_subject === 8 || tmp0_subject === 6) {
        tokenStack.x(lastToken);
      } else if (tmp0_subject === 9) {
        if (!(last(tokenStack) === 8))
          throw JsonDecodingException_0(this.t13_1, 'found ] instead of } at path: ' + this.u13_1.toString(), this.r1d());
        removeLast(tokenStack);
      } else if (tmp0_subject === 7) {
        if (!(last(tokenStack) === 6))
          throw JsonDecodingException_0(this.t13_1, 'found } instead of ] at path: ' + this.u13_1.toString(), this.r1d());
        removeLast(tokenStack);
      } else if (tmp0_subject === 10) {
        this.y17('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.i19();
      if (tokenStack.z() === 0)
        return Unit_instance;
    }
  };
  protoOf(AbstractJsonLexer).toString = function () {
    return "JsonReader(source='" + toString(this.r1d()) + "', currentPosition=" + this.t13_1 + ')';
  };
  protoOf(AbstractJsonLexer).t1a = function (key) {
    var processed = this.y1d(0, this.t13_1);
    var lastIndexOf_0 = lastIndexOf(processed, key);
    throw new JsonDecodingException("Encountered an unknown key '" + key + "' at offset " + lastIndexOf_0 + ' at path: ' + this.u13_1.l18() + "\nUse 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.\n" + ('JSON input: ' + toString(minify(this.r1d(), lastIndexOf_0))));
  };
  protoOf(AbstractJsonLexer).x17 = function (message, position, hint) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(hint) === 0) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    var hintMessage = tmp;
    throw JsonDecodingException_0(position, message + ' at path: ' + this.u13_1.l18() + hintMessage, this.r1d());
  };
  protoOf(AbstractJsonLexer).y17 = function (message, position, hint, $super) {
    position = position === VOID ? this.t13_1 : position;
    hint = hint === VOID ? '' : hint;
    return $super === VOID ? this.x17(message, position, hint) : $super.x17.call(this, message, position, hint);
  };
  protoOf(AbstractJsonLexer).e1b = function () {
    var current = this.u1d();
    current = this.s1d(current);
    if (current >= charSequenceLength(this.r1d()) || current === -1) {
      this.y17('EOF');
    }
    var tmp;
    if (charSequenceGet(this.r1d(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.r1d())) {
        this.y17('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = new Long(0, 0);
    var exponentAccumulator = new Long(0, 0);
    var isNegative = false;
    var isExponentPositive = false;
    var hasExponent = false;
    var start = current;
    $l$loop_4: while (!(current === charSequenceLength(this.r1d()))) {
      var ch = charSequenceGet(this.r1d(), current);
      if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
        if (current === start) {
          this.y17('Unexpected symbol ' + toString_1(ch) + ' in numeric literal');
        }
        isExponentPositive = true;
        hasExponent = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
        if (current === start) {
          this.y17("Unexpected symbol '-' in numeric literal");
        }
        isExponentPositive = false;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
        if (current === start) {
          this.y17("Unexpected symbol '+' in numeric literal");
        }
        isExponentPositive = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45)) {
        if (!(current === start)) {
          this.y17("Unexpected symbol '-' in numeric literal");
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_4;
      current = current + 1 | 0;
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.y17("Unexpected symbol '" + toString_1(ch) + "' in numeric literal");
      }
      if (hasExponent) {
        // Inline function 'kotlin.Long.times' call
        var this_0 = exponentAccumulator;
        // Inline function 'kotlin.Long.plus' call
        var this_1 = multiply(this_0, fromInt(10));
        exponentAccumulator = add(this_1, fromInt(digit));
        continue $l$loop_4;
      }
      // Inline function 'kotlin.Long.times' call
      var this_2 = accumulator;
      // Inline function 'kotlin.Long.minus' call
      var this_3 = multiply(this_2, fromInt(10));
      accumulator = subtract(this_3, fromInt(digit));
      if (compare(accumulator, new Long(0, 0)) > 0) {
        this.y17('Numeric value overflow');
      }
    }
    var hasChars = !(current === start);
    if (start === current || (isNegative && start === (current - 1 | 0))) {
      this.y17('Expected numeric literal');
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.y17('EOF');
      }
      if (!(charSequenceGet(this.r1d(), current) === _Char___init__impl__6a9atx(34))) {
        this.y17('Expected closing quotation mark');
      }
      current = current + 1 | 0;
    }
    this.t13_1 = current;
    if (hasExponent) {
      var doubleAccumulator = toNumber(accumulator) * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
      if (doubleAccumulator > toNumber(new Long(-1, 2147483647)) || doubleAccumulator < toNumber(new Long(0, -2147483648))) {
        this.y17('Numeric value overflow');
      }
      // Inline function 'kotlin.math.floor' call
      if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
        this.y17("Can't convert " + doubleAccumulator + ' to Long');
      }
      accumulator = numberToLong(doubleAccumulator);
    }
    var tmp_0;
    if (isNegative) {
      tmp_0 = accumulator;
    } else if (!equalsLong(accumulator, new Long(0, -2147483648))) {
      tmp_0 = negate(accumulator);
    } else {
      this.y17('Numeric value overflow');
    }
    return tmp_0;
  };
  protoOf(AbstractJsonLexer).u15 = function () {
    var result = this.e1b();
    var next = this.i19();
    if (!(next === 10)) {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
      var expected = tokenDescription(10);
      var position = true ? this.t13_1 - 1 | 0 : this.t13_1;
      var s = this.t13_1 === charSequenceLength(this.r1d()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.r1d(), position));
      var tmp$ret$1 = "Expected input to contain a single valid number, but got '" + s + "' after it";
      this.y17(tmp$ret$1, position);
    }
    return result;
  };
  protoOf(AbstractJsonLexer).d1b = function () {
    var current = this.u1d();
    if (current === charSequenceLength(this.r1d())) {
      this.y17('EOF');
    }
    var tmp;
    if (charSequenceGet(this.r1d(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean2(this, current);
    if (hasQuotation) {
      if (this.t13_1 === charSequenceLength(this.r1d())) {
        this.y17('EOF');
      }
      if (!(charSequenceGet(this.r1d(), this.t13_1) === _Char___init__impl__6a9atx(34))) {
        this.y17('Expected closing quotation mark');
      }
      this.t13_1 = this.t13_1 + 1 | 0;
    }
    return result;
  };
  function charToTokenClass(c) {
    var tmp;
    // Inline function 'kotlin.code' call
    if (Char__toInt_impl_vasixd(c) < 126) {
      var tmp_0 = CharMappings_getInstance().a1e_1;
      // Inline function 'kotlin.code' call
      tmp = tmp_0[Char__toInt_impl_vasixd(c)];
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function tokenDescription(token) {
    return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
  }
  function escapeToChar(c) {
    return c < 117 ? CharMappings_getInstance().z1d_1[c] : _Char___init__impl__6a9atx(0);
  }
  function initEscape($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2ESC($this, i, _Char___init__impl__6a9atx(117));
      }
       while (inductionVariable <= 31);
    initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
    initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
    initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
    initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
    initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
    initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
    initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
    initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
  }
  function initCharToToken($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2TC($this, i, 127);
      }
       while (inductionVariable <= 32);
    initC2TC($this, 9, 3);
    initC2TC($this, 10, 3);
    initC2TC($this, 13, 3);
    initC2TC($this, 32, 3);
    initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
    initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
    initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
    initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
    initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
    initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
    initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
    initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
  }
  function initC2ESC($this, c, esc) {
    if (!(esc === _Char___init__impl__6a9atx(117))) {
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
      $this.z1d_1[tmp$ret$0] = numberToChar(c);
    }
  }
  function initC2ESC_0($this, c, esc) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2ESC($this, tmp$ret$0, esc);
  }
  function initC2TC($this, c, cl) {
    $this.a1e_1[c] = cl;
  }
  function initC2TC_0($this, c, cl) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2TC($this, tmp$ret$0, cl);
  }
  function CharMappings() {
    CharMappings_instance = this;
    this.z1d_1 = charArray(117);
    this.a1e_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
  var CharMappings_instance;
  function CharMappings_getInstance() {
    if (CharMappings_instance == null)
      new CharMappings();
    return CharMappings_instance;
  }
  function StringJsonLexerWithComments(source) {
    StringJsonLexer.call(this, source);
  }
  protoOf(StringJsonLexerWithComments).i19 = function () {
    var source = this.r1d();
    var cpos = this.u1d();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.t13_1 = cpos + 1 | 0;
    return charToTokenClass(charCodeAt(source, cpos));
  };
  protoOf(StringJsonLexerWithComments).e19 = function () {
    var current = this.u1d();
    if (current >= this.r1d().length || current === -1)
      return false;
    return this.v1d(charCodeAt(this.r1d(), current));
  };
  protoOf(StringJsonLexerWithComments).p1a = function (expected) {
    var source = this.r1d();
    var current = this.u1d();
    if (current >= source.length || current === -1) {
      this.t13_1 = -1;
      this.w1d(expected);
    }
    var c = charCodeAt(source, current);
    this.t13_1 = current + 1 | 0;
    if (c === expected)
      return Unit_instance;
    else {
      this.w1d(expected);
    }
  };
  protoOf(StringJsonLexerWithComments).d19 = function () {
    var source = this.r1d();
    var cpos = this.u1d();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.t13_1 = cpos;
    return charToTokenClass(charCodeAt(source, cpos));
  };
  protoOf(StringJsonLexerWithComments).u1d = function () {
    var current = this.t13_1;
    if (current === -1)
      return current;
    var source = this.r1d();
    $l$loop_1: while (current < source.length) {
      var c = charCodeAt(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop_1;
      }
      if (c === _Char___init__impl__6a9atx(47) && (current + 1 | 0) < source.length) {
        var tmp0_subject = charCodeAt(source, current + 1 | 0);
        if (tmp0_subject === _Char___init__impl__6a9atx(47)) {
          current = indexOf_0(source, _Char___init__impl__6a9atx(10), current + 2 | 0);
          if (current === -1) {
            current = source.length;
          } else {
            current = current + 1 | 0;
          }
          continue $l$loop_1;
        } else if (tmp0_subject === _Char___init__impl__6a9atx(42)) {
          current = indexOf(source, '*/', current + 2 | 0);
          if (current === -1) {
            this.t13_1 = source.length;
            this.y17('Expected end of the block comment: "*/", but had EOF instead');
          } else {
            current = current + 2 | 0;
          }
          continue $l$loop_1;
        }
      }
      break $l$loop_1;
    }
    this.t13_1 = current;
    return current;
  };
  function StringJsonLexer(source) {
    AbstractJsonLexer.call(this);
    this.k1e_1 = source;
  }
  protoOf(StringJsonLexer).r1d = function () {
    return this.k1e_1;
  };
  protoOf(StringJsonLexer).s1d = function (position) {
    return position < this.r1d().length ? position : -1;
  };
  protoOf(StringJsonLexer).i19 = function () {
    var source = this.r1d();
    var cpos = this.t13_1;
    $l$loop: while (!(cpos === -1) && cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charCodeAt(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.t13_1 = cpos;
      return charToTokenClass(c);
    }
    this.t13_1 = source.length;
    return 10;
  };
  protoOf(StringJsonLexer).e19 = function () {
    var current = this.t13_1;
    if (current === -1)
      return false;
    var source = this.r1d();
    $l$loop: while (current < source.length) {
      var c = charCodeAt(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.t13_1 = current;
      return this.v1d(c);
    }
    this.t13_1 = current;
    return false;
  };
  protoOf(StringJsonLexer).u1d = function () {
    var current = this.t13_1;
    if (current === -1)
      return current;
    var source = this.r1d();
    $l$loop: while (current < source.length) {
      var c = charCodeAt(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.t13_1 = current;
    return current;
  };
  protoOf(StringJsonLexer).p1a = function (expected) {
    if (this.t13_1 === -1) {
      this.w1d(expected);
    }
    var source = this.r1d();
    var cpos = this.t13_1;
    $l$loop: while (cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charCodeAt(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.t13_1 = cpos;
      if (c === expected)
        return Unit_instance;
      this.w1d(expected);
    }
    this.t13_1 = -1;
    this.w1d(expected);
  };
  protoOf(StringJsonLexer).v1a = function () {
    this.p1a(_Char___init__impl__6a9atx(34));
    var current = this.t13_1;
    var closingQuote = indexOf_0(this.r1d(), _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.g19();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
      var expected = tokenDescription(1);
      var position = false ? this.t13_1 - 1 | 0 : this.t13_1;
      var s = this.t13_1 === charSequenceLength(this.r1d()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.r1d(), position));
      var tmp$ret$1 = 'Expected ' + expected + ", but had '" + s + "' instead";
      this.y17(tmp$ret$1, position);
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charCodeAt(this.r1d(), i) === _Char___init__impl__6a9atx(92)) {
          return this.consumeString2(this.r1d(), this.t13_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.t13_1 = closingQuote + 1 | 0;
    return substring(this.r1d(), current, closingQuote);
  };
  protoOf(StringJsonLexer).x1a = function (keyToMatch, isLenient) {
    var positionSnapshot = this.t13_1;
    try {
      if (!(this.i19() === 6))
        return null;
      var firstKey = this.s1a(isLenient);
      if (!(firstKey === keyToMatch))
        return null;
      this.x1d();
      if (!(this.i19() === 5))
        return null;
      return this.s1a(isLenient);
    }finally {
      this.t13_1 = positionSnapshot;
      this.x1d();
    }
  };
  function StringJsonLexer_0(json, source) {
    return !json.e13_1.g15_1 ? new StringJsonLexer(source) : new StringJsonLexerWithComments(source);
  }
  function get_schemaCache(_this__u8e3s4) {
    return _this__u8e3s4.g13_1;
  }
  function JsonToStringWriter() {
    this.j13_1 = StringBuilder_init_$Create$_0(128);
  }
  protoOf(JsonToStringWriter).c17 = function (value) {
    this.j13_1.qa(value);
  };
  protoOf(JsonToStringWriter).w16 = function (char) {
    this.j13_1.s(char);
  };
  protoOf(JsonToStringWriter).y16 = function (text) {
    this.j13_1.q(text);
  };
  protoOf(JsonToStringWriter).i17 = function (text) {
    printQuoted(this.j13_1, text);
  };
  protoOf(JsonToStringWriter).k13 = function () {
    this.j13_1.ta();
  };
  protoOf(JsonToStringWriter).toString = function () {
    return this.j13_1.toString();
  };
  function createMapForCache(initialCapacity) {
    return HashMap_init_$Create$(initialCapacity);
  }
  //region block: post-declaration
  protoOf(defer$1).ek = get_isNullable;
  protoOf(defer$1).nk = get_isInline;
  protoOf(defer$1).pk = get_annotations;
  protoOf(JsonSerializersModuleValidator).x12 = contextual;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Tombstone_instance = new Tombstone();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = JsonObjectSerializer_getInstance;
  _.$_$.b = JsonArray;
  _.$_$.c = JsonObjectBuilder;
  _.$_$.d = JsonPrimitive_0;
  _.$_$.e = JsonPrimitive_1;
  _.$_$.f = Json_0;
  _.$_$.g = put_0;
  _.$_$.h = put;
  _.$_$.i = put_1;
  //endregion
  return _;
}));

